<template>
  <div v-title title="资料填写">
    <div class="hred">
      <img id="u51_img" class="img " src="@/images/shenqin/u51.png"/>
      <img id="u52_img" class="img " src="@/images/shenqin/u52.png"/>
    </div>
    <div class="jindu">
      <div><p :class="{p2:type>0}">1</p><span :class="{span2:type>0}">基础信息校验</span></div>
      <div><img class="imgx " src="@/images/biaodan/u75.png"></div>
      <div><p :class="{p2:type>1,p1:type==1}">2</p><span :class="{span2:type>1,span1:type==1}">从业人员</span></div>
      <div><img class="imgx " src="@/images/biaodan/u75.png"></div>
      <div><p :class="{p2:type>1&&type!=5,p1:type==1||type==5}">3</p><span
          :class="{span2:type>1&&type!=5,span1:type==1||type==5}">培训场地</span></div>
      <div><img class="imgx " src="@/images/biaodan/u75.png"></div>
      <div><p :class="{p2:type>2&&type!=5,p1:type<3||type==5}">4</p><span
          :class="{span2:type>2&&type!=5,span1:type<3||type==5}">安全措施</span></div>
      <div><img class="imgx " src="@/images/biaodan/u75.png"></div>
      <div><p :class="{p2:type>3&&type!=5,p1:type<4||type==5}">5</p><span
          :class="{span2:type>3&&type!=5,span1:type<4||type==5}">设施器材</span></div>
    </div>
    <div style="margin-top: 20px;margin-bottom: 20px;">
      <img class="img " src="@/images/biaodan/u113.png">
    </div>
  </div>
  <!-- 表单1 -->
  <el-form ref="form" :model="form" label-width="80px" v-if="type==1">
    <el-row>
      <el-col :span="24" v-if="this.yyzz">
        <el-form-item label-width="140px" class="hang" label="机构名称" prop="companyName">
          <el-input class="inputs" v-model="form.companyName" @input="inputnow"/>
          <span class="xing">*</span><span class="bei">请输入备案机构名称</span>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="!this.yyzz">
        <el-form-item label-width="140px" class="hang" label="申报名称" prop="companyName">
          <el-input class="inputs" v-model="form.companyName" @input="inputnow"/>
          <span class="xing">*</span><span class="bei">请输入备案申报名称</span>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="!this.yyzz">
        <el-form-item label-width="140px" class="hang" label="申报名称预留" prop="institutionalRulesAndRegulations">
          <el-input class="inputs" disabled style="width:35%" v-model="form.notice"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="notice"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUploads"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
          </el-upload>
          <span class="xing">*</span><span class="bei">请上传申报名称预留告知书截图</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label-width="140px" class="hang" label="机构类型" prop="organizationType">
          <el-select class="selects" v-model="form.organizationType" placeholder="请选择" @change="changeBoundary">
            <el-option
                v-for="item in organizationArr"
                :key="item.id"
                :label="item.label"
                :value="item.id"
            ></el-option>
          </el-select>
          <span class="xing">*</span><span class="bei">请选择机构类型</span>
        </el-form-item>
      </el-col>
      <el-col v-if="form.organizationType ==1&&yyzz" :span="24">
        <el-form-item label-width="140px" class="hang" label="原有营业执照" prop="institutionalRulesAndRegulations">
          <el-input class="inputs" disabled style="width:35%" v-model="form.yylicense"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="yylicense"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUploads"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
          </el-upload>
          <span class="xing">*</span><span class="bei">原有营业执照</span>
        </el-form-item>
      </el-col>
      <el-col v-if="form.organizationType ==0&&yyzz" :span="24">
        <el-form-item label-width="140px" class="hang" label="民非证书" prop="institutionalRulesAndRegulations">
          <el-input class="inputs" disabled style="width:35%" v-model="form.yycivilnon"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="yycivilnon"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUploads"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
          </el-upload>
          <span class="xing">*</span><span class="bei">民非证书</span>
        </el-form-item>
      </el-col>
      <!--      <el-col :span="24" v-if="this.yyzz">-->
      <!--        <el-form-item label-width="140px" class="hang" label="营业执照" prop="institutionalRulesAndRegulations">-->
      <!--          <el-input class="inputs" disabled style="width:35%" v-model="form.businessLicense"/>-->
      <!--          <el-upload class="upload-demo"-->
      <!--                     ref="upload"-->
      <!--                     :multiple="false"-->
      <!--                     name="yyzz"-->
      <!--                     :show-file-list="false"-->
      <!--                     action="void"-->
      <!--                     :http-request="customUpload"-->
      <!--                     :before-upload="beforeUploadFile1"-->
      <!--                     :auto-upload="true">-->
      <!--            <div class="buttons1">上传</div>-->
      <!--            &lt;!&ndash; slot="trigger" 为触发文件选择框的内容 &ndash;&gt;-->
      <!--          </el-upload>-->


      <!--          <span class="xing">*</span><span class="bei">请上传营业执照</span>-->
      <!--        </el-form-item>-->
      <!--      </el-col>-->
      <el-col :span="24" v-if="this.yyzz">
        <el-form-item label-width="140px" class="hang" label="社会统一代码" prop="personLiableIdCard">
          <el-input class="inputs" v-model="form.socialUnifiedCode" @input="inputnow"/>
          <span class="xing">*</span><span class="bei">请输入公司社会统一代码</span>
        </el-form-item>
      </el-col>
      <el-col v-if="yyzz" :span="24">
        <el-form-item label-width="140px" class="hang" label="高危体育项目" prop="highRiskSports">
          <el-select class="selects" v-model="form.highRiskSports" placeholder="请选择" @change="changeBoundary1">
            <el-option
                v-for="item in highRiskSportsArr"
                :key="item.id"
                :label="item.label"
                :value="item.id"
            ></el-option>
          </el-select>
          <span class="xing">*</span><span class="bei">请选择</span>
        </el-form-item>
      </el-col>
      <el-col v-if="form.highRiskSports ==1" :span="24">
        <el-form-item label-width="140px" class="hang" label="高危许可证" prop="institutionalRulesAndRegulations">
          <el-input class="inputs" disabled style="width:35%" v-model="form.certificate"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="certificate"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUploads"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
          </el-upload>
          <span class="xing">*</span><span class="bei">经营高危险行体育项目许可证</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label-width="140px" class="hang" label="举办者性质" prop="highRiskSports">
          <el-select class="selects" v-model="form.quality" placeholder="请选择" @change="changeBoundary3">
            <el-option
                v-for="item in jbzxz"
                :key="item.id"
                :label="item.label"
                :value="item.id"
            ></el-option>
          </el-select>
          <span class="xing">*</span><span class="bei">请选择</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item v-if="!this.yyzz1" label-width="140px" class="hang" label="举办者" prop="organizer">
          <el-input class="inputs" style="width: 20%" v-model="form.organizer" @input="inputnow"/>
          <el-checkbox style="margin-left: 38px;" v-model="checked">与责任者一致</el-checkbox>
          <span class="xing">*</span><span class="bei">请输入举办者真实姓名</span>
        </el-form-item>
      </el-col>
      <el-col v-if="!this.yyzz1" :span="24">
        <el-form-item label-width="140px" class="hang" label="身份证号码" prop="organizerIdCard">
          <el-input class="inputs" v-model="form.organizerIdCard" @input="inputnow"/>
          <span class="xing">*</span><span class="bei">请输入举办者身份证号码</span>
        </el-form-item>
      </el-col>
      <el-col v-if="!this.yyzz1" :span="24">
        <el-form-item label-width="140px" class="hang" label="举办者身份证正面" prop="institutionalRulesAndRegulations">
          <el-input class="inputs" disabled style="width:35%" v-model="form.organizerIdCardz"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="organizerIdCardz"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload"
                     :before-upload="beforeUploadFile1"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>


          <span class="xing">*</span><span class="bei">请上传举办者身份证正面</span>
        </el-form-item>
      </el-col>
      <el-col v-if="!this.yyzz1" :span="24">
        <el-form-item label-width="140px" class="hang" label="举办者身份证反面" prop="institutionalRulesAndRegulations">
          <el-input class="inputs" disabled style="width:35%" v-model="form.organizerIdCardf"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="organizerIdCardf"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload"
                     :before-upload="beforeUploadFile1"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>
          <span class="xing">*</span><span class="bei">请上传举办者身份证反面</span>
        </el-form-item>
      </el-col>
      <el-col v-if="!this.yyzz1" :span="24">
        <el-form-item label-width="140px" class="hang" label="举办者无犯罪证明" prop="institutionalRulesAndRegulations">
          <el-input class="inputs" disabled style="width:35%" v-model="form.crimej"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="crimej"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload"
                     :before-upload="beforeUploadFile1"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>


          <span class="xing">*</span><span class="bei">请上传举办者无犯罪证明</span>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="this.yyzz1">
        <el-form-item label-width="140px" class="hang" label="营业执照" prop="institutionalRulesAndRegulations">
          <el-input class="inputs" disabled style="width:35%" v-model="form.businessLicensej"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="yyzz1"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload"
                     :before-upload="beforeUploadFile1"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>


          <span class="xing">*</span><span class="bei">请上传营业执照</span>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="this.yyzz1">
        <el-form-item label-width="140px" class="hang" label="社会统一代码" prop="personLiableIdCard">
          <el-input class="inputs" v-model="form.socialUnifiedCodej" @input="inputnow"/>
          <span class="xing">*</span><span class="bei">请输入公司社会统一代码</span>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="this.yyzz1">
        <el-form-item label-width="140px" class="hang" label="信用中国" prop="institutionalRulesAndRegulations">
          <el-input class="inputs" disabled style="width:35%" v-model="form.credit"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="credit"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUploads"
                     :before-upload="beforeUploadFile1"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>


          <span class="xing">*</span><span class="bei">未被列入失信执行人员名单截屏和未被列入企业经营异常名录截屏</span>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="this.yyzz1">
        <el-form-item label-width="140px" class="hang" label="法人姓名" prop="personLiableIdCard">
          <el-input class="inputs" v-model="form.frname" @input="inputnow"/>
          <span class="xing">*</span><span class="bei">请输入法人姓名</span>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="this.yyzz1">
        <el-form-item label-width="140px" class="hang" label="法人身份证号" prop="personLiableIdCard">
          <el-input class="inputs" v-model="form.fridcard" @input="inputnow"/>
          <span class="xing">*</span><span class="bei">请输入法人身份证号</span>
        </el-form-item>
      </el-col>
      <el-col v-if="this.yyzz1" :span="24">
        <el-form-item label-width="140px" class="hang" label="法人身份证正面" prop="institutionalRulesAndRegulations">
          <el-input class="inputs" disabled style="width:35%" v-model="form.fridcardz"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="fridcardz"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUploads"
                     :before-upload="beforeUploadFile1"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>


          <span class="xing">*</span><span class="bei">请上传法人身份证正面</span>
        </el-form-item>
      </el-col>
      <el-col v-if="this.yyzz1" :span="24">
        <el-form-item label-width="140px" class="hang" label="法人身份证反面" prop="institutionalRulesAndRegulations">
          <el-input class="inputs" disabled style="width:35%" v-model="form.fridcardf"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="fridcardf"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUploads"
                     :before-upload="beforeUploadFile1"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>
          <span class="xing">*</span><span class="bei">请上传法人身份证反面</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label-width="140px" class="hang" label="委托人" prop="organizer">
          <el-input class="inputs" style="width: 41%" v-model="form.clientname" @input="inputnow"/>
          <span class="bei" style="margin-left: 5%">请输入委托人真实姓名</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label-width="140px" class="hang" label="委托人身份证正面" prop="institutionalRulesAndRegulations">
          <el-input class="inputs" disabled style="width:35%" v-model="form.clientidcardz"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="clientidcardz"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUploads"
                     :before-upload="beforeUploadFile1"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>


          <span class="bei" style="margin-left: 5%">请上传委托人身份证正面</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label-width="140px" class="hang" label="委托人身份证反面" prop="institutionalRulesAndRegulations">
          <el-input class="inputs" disabled style="width:35%" v-model="form.clientidcardf"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="clientidcardf"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUploads"
                     :before-upload="beforeUploadFile1"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>
          <span class="bei" style="margin-left: 5%">请上传委托人身份证反面</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label-width="140px" class="hang" label="委托书" prop="institutionalRulesAndRegulations">
          <el-input class="inputs" disabled style="width:35%" v-model="form.attorney"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="attorney"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUploads"
                     :before-upload="beforeUploadFile1"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>
          <span class="bei" style="margin-left: 5%">请上传委托书</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label-width="140px" class="hang" label="手机号码" prop="phone">
          <el-input class="inputs" v-model="form.phone" @input="inputnow"/>
          <span class="xing">*</span><span class="bei">请输入举办者手机号码</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label-width="140px" class="hang" label="图形验证码" prop="code">
          <el-input class="inputs" style="width: 25%" v-model="iconv" @input="inputnow"/>
          <img :src="this.baseUrl" class="buttons" @click="getimgcode"/>
          <span class="xing">*</span><span class="bei">请输入图形验证码</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label-width="140px" class="hang" label="短信验证码" prop="code">
          <el-input class="inputs" style="width: 25%" v-model="form.code" @input="inputnow"/>
          <div class="buttons" @click="getcode">{{ getcodetitle }}</div>
          <span class="xing">*</span><span class="bei">请输入短信验证码</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label-width="140px" class="hang" label="注册资金" prop="registeredCapital">
          <el-input class="inputs" v-model="form.registeredCapital" @input="inputnow"/>
          <span style="margin-left: -51px;z-index: 99; margin-right: 15px;">万(元)</span><span class="xing">*</span><span
            class="bei">请输入注册资金</span>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="!checked">
        <el-form-item label-width="140px" class="hang" label="责任者" prop="personLiable">
          <el-input class="inputs" v-model="form.personLiable" @input="inputnow"/>
          <span class="xing">*</span><span class="bei">请输入责任者真实姓名</span>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="!checked">
        <el-form-item label-width="140px" class="hang" label="身份证号码" prop="personLiableIdCard">
          <el-input class="inputs" v-model="form.personLiableIdCard" @input="inputnow"/>
          <span class="xing">*</span><span class="bei">请输入责任者身份证号码</span>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="!checked">
        <el-form-item label-width="140px" class="hang" label="责任者身份证正面" prop="institutionalRulesAndRegulations">
          <el-input class="inputs" disabled style="width:35%" v-model="form.personLiableIdCardz"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="personLiableIdCardz"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload"
                     :before-upload="beforeUploadFile1"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>


          <span class="xing">*</span><span class="bei">请上传责任者身份证正面</span>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="!checked">
        <el-form-item label-width="140px" class="hang" label="责任者身份证反面" prop="institutionalRulesAndRegulations">
          <el-input class="inputs" disabled style="width:35%" v-model="form.personLiableIdCardf"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="personLiableIdCardf"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload"
                     :before-upload="beforeUploadFile1"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>


          <span class="xing">*</span><span class="bei">请上传责任者身份证反面</span>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="!checked">
        <el-form-item label-width="140px" class="hang" label="责任者无犯罪证明" prop="institutionalRulesAndRegulations">
          <el-input class="inputs" disabled style="width:35%" v-model="form.crimez"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     name="crimez"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload"
                     :before-upload="beforeUploadFile1"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>


          <span class="xing">*</span><span class="bei">请上传责任者无犯罪证明</span>
        </el-form-item>
      </el-col>

      <el-col :span="24" v-if="this.yyzz">
        <el-form-item label-width="140px" class="hang" label="开户行" prop="personLiableIdCard">
          <el-input class="inputs" v-model="form.deposit" @input="inputnow"/>
          <span class="xing">*</span><span class="bei">请输入开户行</span>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="this.yyzz">
        <el-form-item label-width="140px" class="hang" label="银行卡号" prop="personLiableIdCard">
          <el-input class="inputs" v-model="form.cardnumber" @input="inputnow"/>
          <span class="xing">*</span><span class="bei">请输入银行卡号</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label-width="140px" class="hang" label="机构规章制度" prop="institutionalRulesAndRegulations">
          <el-input class="inputs" disabled style="width:35%" v-model="form.institutionalRulesAndRegulations"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     :multiple="false"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload"
                     :before-upload="beforeUploadFile"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>


          <span class="xing">*</span><span class="bei">请上传机构章程及内部管理规章制度</span>
        </el-form-item>
      </el-col>
      <div style="margin-top: 20px;margin-bottom: 20px;">
        <img class="img " src="@/images/biaodan/u113.png">
      </div>
      <div class="buttons2" size="mini" @click="jichutijiao">下一步</div>
    </el-row>
  </el-form>
  <!--  表单2-->
  <el-form ref="form2" :model="form2" label-width="80px" v-if="type==2">
    <el-row>
      <el-col :span="24">
        <el-form-item label-width="140px" class="hang" label="所属地区">
          <el-select
              style="width: 13%;margin-right: 1%"
              v-model="form2.province"
              placeholder="省"
              @change="changeCode($event,0)"
          >
            <el-option
                v-for="item in provinceArry"
                :key="item.code"
                :label="item.name"
                :value="item.code"
            ></el-option>
          </el-select>
          <el-select
              style="width: 13%;margin-right:1%"
              class="center_select"
              v-model="form2.city"
              placeholder="市"
              @change="changeCode($event,1)"
          >
            <el-option
                v-for="item in cityArry"
                :key="item.code"
                :label="item.name"
                :value="item.code"
            ></el-option>
          </el-select>
          <el-select
              style="width: 13%;"
              v-model="form2.district"
              placeholder="区"
              @change="changeCode($event,2)"
          >
            <el-option
                v-for="item in districtArry"
                :key="item.code"
                :label="item.name"
                :value="item.code"
            ></el-option>
          </el-select>
          <span class="xing">*</span><span class="bei">请输入场地所属区域</span>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label-width="140px" class="hang" label="详细地址" prop="address">
          <el-input class="inputs" v-model="form2.address" @input="inputnow"/>
          <span class="xing">*</span><span class="bei">请输入详细地址</span>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label-width="140px" class="hang" label="场地性质" prop="siteType">
          <el-select class="selects" v-model="form2.siteType" placeholder="请选择" @change="changeBoundary2">
            <el-option
                v-for="item in siteTypeArry"
                :key="item.id"
                :label="item.label"
                :value="item.id"
            ></el-option>
          </el-select>
          <span class="xing">*</span><span class="bei">请选择场地性质</span>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label-width="140px" v-if="this.form2.siteType==1" class="hang"
                      label="产权证明" prop="institutionalRulesAndRegulations">
          <el-input class="inputs" disabled style="width:35%" v-model="form2.certificateOfPropertyRights"/>
          <el-upload class="upload-demo"
                     name="certificateOfPropertyRights"
                     ref="upload"
                     :multiple="false"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload1"
                     :before-upload="beforeUploadFile1"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>
          <span class="xing">*</span><span class="bei">请上传产权证明</span>
        </el-form-item>
        <el-form-item label-width="140px" v-if="this.form2.siteType==2" class="hang"
                      label="租赁合同" prop="institutionalRulesAndRegulations">
          <el-input class="inputs" disabled style="width:35%" v-model="form2.certificateOfPropertyRights"/>
          <el-upload class="upload-demo"
                     name="certificateOfPropertyRights"
                     ref="upload"
                     :multiple="false"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload1"
                     :before-upload="beforeUploadFile1"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>
          <span class="xing">*</span><span class="bei">请上传租赁合同</span>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label-width="140px" class="hang" label="场地总面积" prop="totalSiteArea">
          <el-input class="inputs" v-model="form2.totalSiteArea" @input="inputnow"/>
          <span style="margin-left: -28px;z-index: 99; margin-right: 15px;">㎡</span><span
            class="xing">*</span><span class="bei">请填写场地总面积</span>
        </el-form-item>
      </el-col>

      <div style="background: #f2f2f2;width: 100%;position:relative;">
        <p style="margin-left: 5%;font-size: 18px;">培训项目内容及材料</p>
        <div style="height: 300px; " v-for="(item,index) in form2.reportDetailsOfTrainingPlacesList" :key="index">
          <el-col :span="12">
            <el-form-item label-width="80px" class="hang" label="培训项目" prop="totalSiteArea">
              <el-select class="selects" v-model="item.trainingPrograms" placeholder="请选择" @change="changeBoundary3">
                <el-option
                    v-for="item in trainingProgramsArry"
                    :key="item.name"
                    :label="item.label"
                    :value="item.name"
                ></el-option>
              </el-select>
              <el-input v-if="item.trainingPrograms==`其他`" style="width: 50%" v-model="item.trainingPrograms1"
                        @input="inputnow"
                        placeholder="请输入培训项目"/>
            </el-form-item>
            <el-form-item label-width="100px" class="hang" style="width: 50%" label="最大班容量" prop="totalSiteArea">
              <el-input v-model="item.numberOfShifts" @input="inputnow"
                        placeholder="最大班容量"/>
              <span style="margin-left: -30px;z-index: 99; margin-right: 15px;">人</span>
            </el-form-item>
            <el-form-item label-width="80px" class="hang" label="课程体系" prop="totalSiteArea">
              <el-input style="width: 80%;" v-model="item.material" disabled
                        @input="inputnow" placeholder="请上传课程体系图片"/>
              <el-upload class="upload-file"
                         name="jiaocai"
                         :data="{index:index}"
                         ref="upload"
                         :multiple="false"
                         :show-file-list="false"
                         action="#"
                         :limit="10"
                         :http-request="customUpload12"
                         :auto-upload="true"
              >
                <div class="buttons1">上传</div>
                <!-- slot="trigger" 为触发文件选择框的内容 -->
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label-width="80px" class="hang" label="教学面积" prop="totalSiteArea">
              <el-input v-model="item.siteArea" @input="inputnow"
                        placeholder="请输入本项目培训教学面积"/>
              <span style="margin-left: -30px;z-index: 99; margin-right: 15px;">㎡</span>
            </el-form-item>
            <el-form-item label-width="80px" class="hang" label="场地现状" prop="totalSiteArea">
              <el-input style="width: 80%;" v-model="item.sitePicture" disabled
                        @input="inputnow" placeholder="请上传场地现状"/>
              <el-upload class="upload-file"
                         name="list"
                         :data="{index:index}"
                         ref="upload"
                         :multiple="false"
                         :show-file-list="false"
                         action="#"
                         :limit="20"
                         :http-request="customUpload12"
                         :auto-upload="true"
              >
                <div class="buttons1">上传</div>
                <!-- slot="trigger" 为触发文件选择框的内容 -->
              </el-upload>
            </el-form-item>
          </el-col>

        </div>
        <div style="display: flex;position: absolute;
    left: 30%;
    bottom: 20px;">
          <el-button style="  position: relative;
  left: 30%;
  width: 99px;
  height: 40px;
  background: inherit;
  background-color: rgba(255, 102, 51, 1);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;" @click="zengjiachangdi"> 增加
          </el-button>
          <el-button style="  position: relative;
  left: 50%;
  width: 99px;
  height: 40px;
  background: inherit;
  background-color: rgba(153, 153, 153, 1);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;" @click="shanchuchangdi"> 删除
          </el-button>
        </div>
      </div>
      <div style="margin-top: 20px;margin-bottom: 20px;">
        <img class="img " src="@/images/biaodan/u113.png">
      </div>
      <div class="buttons3" size="mini" @click="jichutijiao1">上一步</div>
      <div class="buttons2" size="mini" @click="jichutijiao">下一步</div>
    </el-row>
  </el-form>
  <!--  表单3-->
  <el-form ref="form3" :model="form3" label-width="80px" v-if="type==3">
    <el-row>
      <el-col :span="24">
        <el-form-item label-width="140px" class="hang" label="房屋安全鉴定" prop="houseSafetyAppraisal">
          <el-input class="inputs" disabled style="width:35%" v-model="form3.houseSafetyAppraisal"/>
          <el-upload class="upload-demo"
                     name="1"
                     ref="upload"
                     :multiple="false"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload2"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>
          <span class="xing">*</span><span class="bei">请上传房屋安全鉴定证明</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label-width="140px" class="hang" label="消防行政许可备案" prop="filingOfFireAdministrativeLicense">
          <el-input class="inputs" disabled style="width:35%" v-model="form3.filingOfFireAdministrativeLicense"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     name="2"
                     :multiple="false"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload2"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>
          <span class="xing">*</span><span class="bei">请上传消防行政许可备案证明</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label-width="140px" class="hang" label="意外处置预案" prop="contingencyPlan">
          <el-input class="inputs" disabled style="width:35%" v-model="form3.contingencyPlan"/>
          <el-upload class="upload-demo"
                     name="3"
                     ref="upload"
                     :multiple="false"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload2"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>
          <span class="xing">*</span><span class="bei">请打包上传意外突发状况处置预案</span>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label-width="140px" class="hang" label="安全制度" prop="securityInstitution">
          <el-input class="inputs" disabled style="width:35%" v-model="form3.securityInstitution"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     name="5"
                     :multiple="false"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload2"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>
          <span class="xing">*</span><span class="bei">请上传悬挂在明显位置的照片</span>
        </el-form-item>
      </el-col>
      <el-col v-if="this.yyzz" :span="24">
        <el-form-item label-width="140px" class="hang" label="经营场所险" prop="businessPremisesInsurance">
          <el-input class="inputs" disabled style="width:35%" v-model="form3.businessPremisesInsurance"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     name="4"
                     :multiple="false"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload2"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>
          <span class="xing">*</span><span class="bei">请上传经营场所责任险</span>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="this.yyzz">
        <el-form-item label-width="140px" class="hang" label="人员保险" prop="securityInstitution">
          <el-input class="inputs" disabled style="width:35%" v-model="form3.renyuanbaoxian"/>
          <el-upload class="upload-demo"
                     ref="upload"
                     name="6"
                     :multiple="false"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload2"
                     :auto-upload="true">
            <div class="buttons1">上传</div>
            <!-- slot="trigger" 为触发文件选择框的内容 -->
          </el-upload>
          <span class="xing">*</span><span class="bei">请上传人员保险</span>
        </el-form-item>
      </el-col>
      <el-col style="width: 70%">
        <el-form-item label-width="140px" class="hang" label="安保人员"
                      v-for="(item,index) in form3.reportSecurityGuardList" :key="index">
          <el-input class="inputs" style="width:20%" @input="inputnow" v-model="item.realName" placeholder="安保人员姓名"/>
          <el-input class="inputs" style="width:20%" @input="inputnow" v-model="item.idCard" placeholder="身份证号码"/>
          <el-input class="inputs" style="width:20%" disabled @input="inputnow" v-model="item.img" placeholder="资质证书"/>

          <el-upload class="upload-demo"
                     :data="{name:'renyuan',index:index}"
                     ref="upload"
                     :multiple="false"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload3"
                     :auto-upload="true">
            <el-button type="primary">上传</el-button>
          </el-upload>

          <div style="margin-left: 20px;">
            <el-button v-if="index==0" @click="addrenyuan" type="danger">增加</el-button>
            <el-button v-if="index>0" @click="delrenyuan(index)" type="info">删除</el-button>
          </div>
        </el-form-item>
      </el-col>
      <el-col style="width: 70%">
        <el-form-item label-width="140px" class="hang" label="医疗急救用品"
                      v-for="(item,index) in form3.reportMedicalFirstAidSuppliesList" :key="index">
          <el-input class="inputs" style="width:20%" @input="inputnow" v-model="item.itemName" placeholder="医疗用品名称"/>
          <el-input class="inputs" style="width:20%" @input="inputnow" v-model="item.unitType" placeholder="品牌/型号"/>
          <el-input class="inputs" style="width:20%" disabled @input="inputnow" v-model="item.img" placeholder="选择照片"/>
          <el-upload class="upload-demo"
                     :data="{name:'jijiu',index:index}"
                     ref="upload"
                     :multiple="false"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload3"
                     :auto-upload="true">
            <el-button type="primary">上传</el-button>
          </el-upload>

          <div style="margin-left: 20px;">
            <el-button v-if="index==0" @click="addjijiu" type="danger">增加</el-button>
            <el-button v-if="index>0" @click="deljijiu(index)" type="info">删除</el-button>
          </div>
        </el-form-item>
      </el-col>

      <el-col style="width: 70%">
        <el-form-item label-width="140px" class="hang" label="急救人员"
                      v-for="(item,index) in form5.Treatment" :key="index">
          <el-input class="inputs" disabled style="width:20%;margin-top: 10px" @input="inputnow" v-model="item.treatmentRealName" placeholder="急救人员姓名"/>
          <el-input class="inputs" disabled style="width:20%;margin-top: 10px"  @input="inputnow" v-model="item.treatmentIdCard" placeholder="急救人员身份证号"/>
          <el-input class="inputs" disabled style="width:20%;margin-top: 10px"  @input="inputnow" v-model="item.treatmentIdCardz" placeholder="急救人员身份证号正面"/>
          <el-input class="inputs" disabled style="width:20%;margin-top: 10px"  @input="inputnow" v-model="item.treatmentIdCardf" placeholder="急救人员身份证号反面"/>
          <el-input class="inputs" disabled style="width:20%;margin-top: 10px"  @input="inputnow" v-model="item.treatmentProfessional" placeholder="从业资格证"/>
          <el-input class="inputs" disabled style="width:20%;margin-top: 10px"  @input="inputnow" v-model="item.treatmentContract" placeholder="劳动合同"/>
          <el-button @click="deljijiury(index)" type="info">删除</el-button>
        </el-form-item>
        <el-form-item label-width="140px" class="hang" label="急救人员">
          <el-col style="display: flex">
            <el-input class="inputs" style="width:41%" @input="inputnow" v-model="Treatment.treatmentRealName"
                      placeholder="急救人员真实姓名"/>
            <el-input class="inputs" style="width:41%" @input="inputnow" v-model="Treatment.treatmentIdCard"
                      placeholder="急救人员身份证号码"/>
            <div style="margin-left: 20px;">

            </div>
          </el-col>
          <el-col style="margin-top: 5px;">
            <el-form-item>
              <el-input class="inputs" style="width:33%" @input="inputnow" disabled
                        v-model="Treatment.treatmentIdCardz"
                        placeholder="身份证正面照片"/>
              <el-upload class="upload-demo"
                         :data="{name:'jjidcardz',index:index}"
                         ref="upload"
                         :multiple="false"
                         :show-file-list="false"
                         action="void"
                         :http-request="customUpload4"
                         :auto-upload="true">
                <el-button type="primary">上传</el-button>
              </el-upload>
              <el-input class="inputs" style="width:33%" @input="inputnow" disabled
                        v-model="Treatment.treatmentIdCardf"
                        placeholder="身份证反面照片"/>
              <el-upload class="upload-demo"
                         :data="{name:'jjidcardf',index:index}"
                         ref="upload"
                         :multiple="false"
                         :show-file-list="false"
                         action="void"
                         :http-request="customUpload4"
                         :auto-upload="true">
                <el-button type="primary">上传</el-button>
              </el-upload>
              <el-input class="inputs" style="width:33%;margin-top: 1%" @input="inputnow" disabled
                        v-model="Treatment.treatmentProfessional"
                        placeholder="从业资格证"/>
              <el-upload class="upload-demo"
                         :data="{name:'jjcyzgz',index:index}"
                         ref="upload"
                         :multiple="false"
                         :show-file-list="false"
                         action="void"
                         :http-request="customUpload4"
                         :auto-upload="true">
                <el-button type="primary">上传</el-button>
              </el-upload>
              <el-input class="inputs" style="width:33%;margin-top: 1%" @input="inputnow" disabled
                        v-model="Treatment.treatmentContract"
                        placeholder="劳动合同"/>
              <el-upload class="upload-demo"
                         :data="{name:'contract3',index:index}"
                         ref="upload"
                         :multiple="false"
                         :show-file-list="false"
                         action="void"
                         :http-request="customUpload4"
                         :auto-upload="true">
                <el-button type="primary">上传</el-button>
              </el-upload>
              <el-button  @click="addjijiury" type="danger">增加</el-button>
            </el-form-item>
          </el-col>
        </el-form-item>
      </el-col>
      <!--      <div style="margin-bottom: 40px;margin-left: 76px;">-->
      <!--        急救人员：-->
      <!--        <div v-for="(item,index) in form5.Treatment" :key="index">-->
      <!--          <div-->
      <!--              style="margin-left: 10%;margin-bottom:10px;width:100%;display: flex;border-bottom: 1px solid rgba(96,96,96,0.66)">-->
      <!--            <span>姓名：</span><span style="margin-right: 30px">{{ item.treatmentRealName }}</span>-->
      <!--            <span>身份证号：</span><span style="margin-right: 30px">{{ item.treatmentIdCard }}</span>-->
      <!--            <span>身份证正面：</span><img style="width: 20px;margin-right: 30px" :src="item.treatmentIdCardz" alt="">-->
      <!--            <span>身份证反面：</span><img style="width: 20px;margin-right: 30px" :src="item.treatmentIdCardf" alt="">-->
      <!--            <el-button @click="deljijiury(index)" type="info">删除</el-button>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <el-col style="width: 100%;margin-left: -10%;">-->
      <!--        <el-form-item label-width="140px" class="hang" label="急救人员">-->
      <!--          <el-col style="display: flex">-->
      <!--            <el-input class="inputs" style="width:41%" @input="inputnow" v-model="Treatment.treatmentRealName"-->
      <!--                      placeholder="急救人员真实姓名"/>-->
      <!--            <el-input class="inputs" style="width:41%" @input="inputnow" v-model="Treatment.treatmentIdCard"-->
      <!--                      placeholder="急救人员身份证号码"/>-->
      <!--            <div style="margin-left: 20px;">-->
      <!--              <el-button @click="addjijiury" type="danger">添加</el-button>-->
      <!--            </div>-->
      <!--          </el-col>-->
      <!--          <el-col style="margin-top: 5px;">-->
      <!--            <el-form-item>-->
      <!--              <el-input class="inputs" style="width:33%" @input="inputnow" disabled-->
      <!--                        v-model="Treatment.treatmentIdCardz"-->
      <!--                        placeholder="身份证正面照片"/>-->
      <!--              <el-upload class="upload-demo"-->
      <!--                         :data="{name:'jjidcardz',index:index}"-->
      <!--                         ref="upload"-->
      <!--                         :multiple="false"-->
      <!--                         :show-file-list="false"-->
      <!--                         action="void"-->
      <!--                         :http-request="customUpload4"-->
      <!--                         :auto-upload="true">-->
      <!--                <el-button type="primary">上传</el-button>-->
      <!--              </el-upload>-->
      <!--              <el-input class="inputs" style="width:33%" @input="inputnow" disabled-->
      <!--                        v-model="Treatment.treatmentIdCardf"-->
      <!--                        placeholder="身份证反面照片"/>-->
      <!--              <el-upload class="upload-demo"-->
      <!--                         :data="{name:'jjidcardf',index:index}"-->
      <!--                         ref="upload"-->
      <!--                         :multiple="false"-->
      <!--                         :show-file-list="false"-->
      <!--                         action="void"-->
      <!--                         :http-request="customUpload4"-->
      <!--                         :auto-upload="true">-->
      <!--                <el-button type="primary">上传</el-button>-->
      <!--              </el-upload>-->
      <!--              <el-input class="inputs" style="width:33%;margin-top: 1%" @input="inputnow" disabled-->
      <!--                        v-model="Treatment.treatmentProfessional"-->
      <!--                        placeholder="从业资格证"/>-->
      <!--              <el-upload class="upload-demo"-->
      <!--                         :data="{name:'jjcyzgz',index:index}"-->
      <!--                         ref="upload"-->
      <!--                         :multiple="false"-->
      <!--                         :show-file-list="false"-->
      <!--                         action="void"-->
      <!--                         :http-request="customUpload4"-->
      <!--                         :auto-upload="true">-->
      <!--                <el-button type="primary">上传</el-button>-->
      <!--              </el-upload>-->
      <!--              <el-input class="inputs" style="width:33%;margin-top: 1%" @input="inputnow" disabled-->
      <!--                        v-model="Treatment.treatmentContract"-->
      <!--                        placeholder="劳动合同"/>-->
      <!--              <el-upload class="upload-demo"-->
      <!--                         :data="{name:'contract3',index:index}"-->
      <!--                         ref="upload"-->
      <!--                         :multiple="false"-->
      <!--                         :show-file-list="false"-->
      <!--                         action="void"-->
      <!--                         :http-request="customUpload4"-->
      <!--                         :auto-upload="true">-->
      <!--                <el-button type="primary">上传</el-button>-->
      <!--              </el-upload>-->
      <!--            </el-form-item>-->
      <!--          </el-col>-->
      <!--        </el-form-item>-->
      <!--      </el-col>-->

      <div style="margin-top: 20px;margin-bottom: 20px;">
        <img class="img " src="@/images/biaodan/u113.png">
      </div>
      <div class="buttons3" size="mini" @click="jichutijiao1">上一步</div>
      <div class="buttons2" size="mini" @click="jichutijiao">下一步</div>
    </el-row>
  </el-form>

  <!--  表单4-->
  <el-form ref="form4" :model="form4" label-width="80px" v-if="type==4">
    <el-row>
      <el-col style="width: 70%">
        <el-form-item label-width="140px" class="hang" label="设施器材"
                      v-for="(item,index) in form4.reportFacilitiesAndEquipmentList" :key="index">
          <el-input class="inputs" style="width:20%" @input="inputnow" v-model="item.itemName" placeholder="输入器材名称"/>
          <el-input class="inputs" style="width:20%" @input="inputnow" v-model="item.unitType" placeholder="品牌/生产厂家"/>
          <el-input class="inputs" style="width:20%" @input="inputnow" disabled v-model="item.img" placeholder="铭牌图片与器材图片"/>

          <el-upload class="upload-demo"
                     :data="{name:'qicai',index:index}"
                     ref="upload"
                     :multiple="false"
                     :show-file-list="false"
                     action="void"
                     :http-request="customUpload3"
                     :auto-upload="true">
            <el-button type="primary">上传</el-button>
          </el-upload>

          <div style="margin-left: 20px;">
            <el-button v-if="index==0" @click="addshebei" type="danger">增加</el-button>
            <el-button v-if="index>0" @click="delshebei(index)" type="info">删除</el-button>
          </div>
        </el-form-item>
      </el-col>
      <div style="margin-top: 20px;margin-bottom: 20px;">
        <img class="img " src="@/images/biaodan/u113.png">
      </div>
      <div class="buttons3" size="mini" @click="jichutijiao1">上一步</div>
      <div class="buttons2" size="mini" @click="jichutijiao">提交审查</div>
    </el-row>
  </el-form>
  <!--  表单5-->
  <el-form ref="form5" :model="form5" label-width="80px" v-if="type==5">
    <el-row style="width: 100%">
      <div style="margin-bottom: 40px;margin-left: 76px;width: 100%">
        其他人员列表：
        <div
            style="margin-left: 5%;margin-top:20px;width:80%;display: flex;background: #e9f2fd">
          <span style="width: 20%;text-align: center;">序号</span>
          <span style="width: 20%;text-align: center;">姓名</span>
          <span style="width: 20%;text-align: center;">份证号</span>
          <span style="width: 20%;text-align: center;">身份证正面</span>
          <span style="width: 20%;text-align: center;">身份证反面</span>
          <span style="width: 20%;text-align: center;">操作</span>
        </div>
        <div v-for="(item,index) in form5.management" :key="index">
          <div
              style="margin-left: 5%;margin-top:20px;width:80%;display: flex;height: 20px;">
            <span style="width: 20%;text-align: center;">{{ index + 1 }}</span>
            <span style="width: 20%;text-align: center;">{{ item.managementRealName }}</span>
            <span style="width: 20%;text-align: center;">{{ item.managementIdCard }}</span>
            <span style="width: 20%;text-align: center;">已上传</span>
            <span style="width: 20%;text-align: center;">已上传</span>
            <span style="width: 20%;text-align: center;">   <el-button @click="delxingzheng(index)"
                                                                       type="info">删除</el-button></span>

          </div>
        </div>
      </div>
      <el-col style="width: 100%;margin-left: -10%;">
        <el-form-item label-width="140px" class="hang" label="其他人员">
          <el-col style="display: flex">
            <el-input class="inputs" style="width:41%" @input="inputnow" v-model="management.managementRealName"
                      placeholder="其他人员真实姓名"/>
            <el-input class="inputs" style="width:41%" @input="inputnow" v-model="management.managementIdCard"
                      placeholder="其他人员身份证号码"/>
          </el-col>
          <el-col style="margin-top: 5px;">
            <el-form-item>
              <div style="width: 30%;margin-right: 3%;margin-left: -4%;   margin-top: 20px; height: 214px;">
                <img :src="management.managementIdcardz" alt="" style="width: 214px;height: 142px"
                >

                <el-upload style="width: 100%;position: relative;top:-156px;"
                           :data="{name:'cysfzz',index:index}"
                           ref="upload"
                           :multiple="false"
                           :show-file-list="false"
                           action="void"
                           :http-request="customUpload4"
                           :auto-upload="true">
                  <el-button type="primary"
                             style="width: 214px;height: 142px;background: none;border:none;color: white;"></el-button>
                  <div
                      style="width: 214px;text-align: center;color: #FFFFFF;position: relative;top: 58px;left: -214px;">
                    上传身份证正面
                  </div>
                </el-upload>
              </div>
              <div style="width: 30%;margin-right: 3%;  margin-top: 20px; height: 214px;">
                <img :src="management.managementIdcardf" alt="" style="width: 214px;height: 142px"
                >

                <el-upload style="width: 100%;position: relative;top:-156px;"
                           :data="{name:'cysfzf',index:index}"
                           ref="upload"
                           :multiple="false"
                           :show-file-list="false"
                           action="void"
                           :http-request="customUpload4"
                           :auto-upload="true">
                  <el-button type="primary" style="width: 214px;height: 142px;background: none;border:none;color: white;
"></el-button>
                  <div
                      style="width: 214px;text-align: center;color: #FFFFFF;position: relative;top: 60px;left: -214px;">
                    上传身份证反面
                  </div>
                </el-upload>
              </div>
              <div style="width: 30%;margin-right: 3%;   margin-top: 20px; height: 214px;">
                <img :src="management.managementContract" alt="" style="width: 214px;height: 142px"
                >

                <el-upload style="width: 100%;position: relative;top:-156px;"
                           :data="{name:'contract1',index:index}"
                           ref="upload"
                           :multiple="false"
                           :show-file-list="false"
                           action="void"
                           :http-request="customUpload4"
                           :auto-upload="true">
                  <el-button type="primary"
                             style="width: 214px;height: 142px;background: none;border:none;color: white;"></el-button>
                  <div
                      style="width: 214px;text-align: center;color: #FFFFFF;position: relative;top: 60px;left: -214px;">
                    上传劳动合同
                  </div>
                </el-upload>
              </div>

            </el-form-item>
          </el-col>
          <el-col style="margin-top: -30px;z-index:99;">
            <el-button
                style="width: 636px;height: 53px;border-radius: 10px;border:1px dotted #c9c9c9;background: #FFFFFF;color: #000000"
                @click="addxingzheng" type="danger">添加
            </el-button>
          </el-col>
        </el-form-item>
      </el-col>

      <div style="margin-bottom: 40px;margin-left: 76px;width: 100%">
        执教人员列表：
        <div
            style="margin-left: 5%;margin-top:20px;width:80%;display: flex;background: #e9f2fd">
          <span style="width: 20%;text-align: center;">序号</span>
          <span style="width: 20%;text-align: center;">姓名</span>
          <span style="width: 20%;text-align: center;">份证号</span>
          <span style="width: 20%;text-align: center;">身份证正面</span>
          <span style="width: 20%;text-align: center;">身份证反面</span>
          <span style="width: 20%;text-align: center;">操作</span>
        </div>
        <div v-for="(item,index) in form5.coachReal" :key="index">
          <div
              style="margin-left: 5%;margin-top:20px;width:80%;display: flex;height: 20px;">
            <span style="width: 20%;text-align: center;">{{ index + 1 }}</span>
            <span style="width: 20%;text-align: center;">{{ item.coachRealName }}</span>
            <span style="width: 20%;text-align: center;">{{ item.coachIdCard }}</span>
            <span style="width: 20%;text-align: center;">已上传</span>
            <span style="width: 20%;text-align: center;">已上传</span>
            <span style="width: 20%;text-align: center;">   <el-button @click="deljiaoyuan(index)"
                                                                       type="info">删除</el-button></span>
          </div>
        </div>
      </div>
      <el-col style="width: 100%;margin-left: -10%;">
        <el-form-item label-width="140px" class="hang" label="执教人员">
          <el-col style="display: flex">
            <el-input class="inputs" style="width:41%" @input="inputnow" v-model="coachReal.coachRealName"
                      placeholder="执教人员真实姓名"/>
            <el-input class="inputs" style="width:41%" @input="inputnow" v-model="coachReal.coachIdCard"
                      placeholder="执教人员身份证号码"/>
          </el-col>
          <el-col style="margin-top: 5px;">
            <el-form-item>
              <div style="width: 30%;margin-right: 3%;margin-left: -20%;   margin-top: 20px; height: 214px;">
                <img :src="coachReal.coachIdCardz" alt="" style="width: 214px;height: 142px"
                >

                <el-upload style="width: 100%;position: relative;top:-156px;"
                           :data="{name:'jlysfzz',index:index}"
                           ref="upload"
                           :multiple="false"
                           :show-file-list="false"
                           action="void"
                           :http-request="customUpload4"
                           :auto-upload="true">
                  <el-button type="primary" style="width: 214px;height: 142px;background: none;border:none;color: white;"></el-button>
                  <div
                      style="width: 214px;text-align: center;color: #FFFFFF;position: relative;top: 60px;left: -214px;">
                    上传身份证正面
                  </div>
                </el-upload>
              </div>
              <div style="width: 30%;margin-right: 3%;  margin-top: 20px; height: 214px;">
                <img :src="coachReal.coachIdCardf" alt="" style="width: 214px;height: 142px"
                >

                <el-upload style="width: 100%;position: relative;top:-156px;"
                           :data="{name:'jlysfzf',index:index}"
                           ref="upload"
                           :multiple="false"
                           :show-file-list="false"
                           action="void"
                           :http-request="customUpload4"
                           :auto-upload="true">
                  <el-button type="primary" style="width: 214px;height: 142px;background: none;border:none;color: white;"></el-button>
                  <div
                      style="width: 214px;text-align: center;color: #FFFFFF;position: relative;top: 60px;left: -214px;">
                    上传身份证反面
                  </div>
                </el-upload>
              </div>
              <div style="width: 30%;margin-right: 3%;  margin-top: 20px; height: 214px;">
                <img :src="coachReal.coachProfessional" alt="" style="width: 214px;height: 142px"
                >

                <el-upload style="width: 100%;position: relative;top:-156px;"
                           :data="{name:'cyzgz',index:index}"
                           ref="upload"
                           :multiple="false"
                           :show-file-list="false"
                           action="void"
                           :http-request="customUpload4"
                           :auto-upload="true">
                  <el-button type="primary" style="width: 214px;height: 142px;background: none;border:none;color: white;"></el-button>
                  <div
                      style="width: 214px;text-align: center;color: #FFFFFF;position: relative;top: 60px;left: -214px;">
                    上传从业资格证
                  </div>
                </el-upload>
              </div>
              <div
                  style="width: 30%;margin-right: 3%;   margin-top: 92px; height: 214px;width: 214px;position: relative;    top: -306px;    left: 560px;">
                <img :src="coachReal.coachContract" alt="" style="width: 214px;height: 142px"
                >

                <el-upload style="width: 100%;position: relative;top:-156px;"
                           :data="{name:'contract',index:index}"
                           ref="upload"
                           :multiple="false"
                           :show-file-list="false"
                           action="void"
                           :http-request="customUpload4"
                           :auto-upload="true">
                  <el-button type="primary" style="width: 214px;height: 142px;background: none;border:none;color: white;"></el-button>
                  <div
                      style="width: 214px;text-align: center;color: #FFFFFF;position: relative;top: 60px;left: -214px;">
                    上传劳动合同
                  </div>
                </el-upload>
              </div>

            </el-form-item>
          </el-col>
          <el-col style="margin-top: -534px;z-index: 99">
            <el-button
                style="width: 636px;height: 53px;border-radius: 10px;border:1px dotted #c9c9c9;background: #FFFFFF;color: #000000"
                @click="addjiaoyuan" type="danger">添加
            </el-button>
          </el-col>
        </el-form-item>
      </el-col>




      <div style="margin-bottom: 40px;margin-left: 76px;width: 100%;margin-top: -178px;">
        教研人员列表：
        <div
            style="margin-left: 5%;margin-top:20px;width:80%;display: flex;background: #e9f2fd">
          <span style="width: 20%;text-align: center;">序号</span>
          <span style="width: 20%;text-align: center;">姓名</span>
          <span style="width: 20%;text-align: center;">份证号</span>
          <span style="width: 20%;text-align: center;">身份证正面</span>
          <span style="width: 20%;text-align: center;">身份证反面</span>
          <span style="width: 20%;text-align: center;">操作</span>
        </div>
        <div v-for="(item,index) in form5.Research" :key="index">
          <div
              style="margin-left: 5%;margin-top:20px;width:80%;display: flex;height: 20px;">
            <span style="width: 20%;text-align: center;">{{ index + 1 }}</span>
            <span style="width: 20%;text-align: center;">{{ item.researchRealName }}</span>
            <span style="width: 20%;text-align: center;">{{ item.researchIdCard }}</span>
            <span style="width: 20%;text-align: center;">已上传</span>
            <span style="width: 20%;text-align: center;">已上传</span>
            <span style="width: 20%;text-align: center;z-index: 99" >   <el-button @click="deljiaoyan(index)"
                                                                       type="info" >删除</el-button></span>
          </div>
        </div>
      </div>
      <el-col style="width: 100%;margin-left: -10%;">
        <el-form-item label-width="140px" class="hang" label="教研人员">
          <el-col style="display: flex">
            <el-input class="inputs" style="width:41%" @input="inputnow" v-model="Research.researchRealName"
                      placeholder="教研人员真实姓名"/>
            <el-input class="inputs" style="width:41%" @input="inputnow" v-model="Research.researchIdCard"
                      placeholder="教研人员身份证号码"/>
          </el-col>
          <el-col style="margin-top: 5px;">
            <el-form-item>
              <div style="width: 30%;margin-right: 3%;margin-left: -20%;   margin-top: 20px; height: 214px;">
                <img :src="Research.researchIdCardz" alt="" style="width: 214px;height: 142px"
                >

                <el-upload style="width: 100%;position: relative;top:-156px;"
                           :data="{name:'jyrysfzz',index:index}"
                           ref="upload"
                           :multiple="false"
                           :show-file-list="false"
                           action="void"
                           :http-request="customUpload4"
                           :auto-upload="true">
                  <el-button type="primary" style="width: 214px;height: 142px;background: none;border:none;color: white;"></el-button>
                  <div
                      style="width: 214px;text-align: center;color: #FFFFFF;position: relative;top: 60px;left: -214px;">
                    上传身份证正面
                  </div>
                </el-upload>
              </div>
              <div style="width: 30%;margin-right: 3%;  margin-top: 20px; height: 214px;">
                <img :src="Research.researchIdCardf" alt="" style="width: 214px;height: 142px"
                >

                <el-upload style="width: 100%;position: relative;top:-156px;"
                           :data="{name:'jyrysfzf',index:index}"
                           ref="upload"
                           :multiple="false"
                           :show-file-list="false"
                           action="void"
                           :http-request="customUpload4"
                           :auto-upload="true">
                  <el-button type="primary" style="width: 214px;height: 142px;background: none;border:none;color: white;"></el-button>
                  <div
                      style="width: 214px;text-align: center;color: #FFFFFF;position: relative;top: 60px;left: -214px;">
                    上传身份证反面
                  </div>
                </el-upload>
              </div>
              <div style="width: 30%;margin-right: 3%;  margin-top: 20px; height: 214px;">
                <img :src="Research.researchProfessional" alt="" style="width: 214px;height: 142px"
                >

                <el-upload style="width: 100%;position: relative;top:-156px;"
                           :data="{name:'jyrycyzgz',index:index}"
                           ref="upload"
                           :multiple="false"
                           :show-file-list="false"
                           action="void"
                           :http-request="customUpload4"
                           :auto-upload="true">
                  <el-button type="primary" style="width: 214px;height: 142px;background: none;border:none;color: white;"></el-button>
                  <div
                      style="width: 214px;text-align: center;color: #FFFFFF;position: relative;top: 60px;left: -214px;">
                    上传从业资格证
                  </div>
                </el-upload>
              </div>
              <div
                  style="width: 30%;margin-right: 3%;   margin-top: 92px; height: 214px;width: 214px;position: relative;    top: -306px;    left: 560px;">
                <img :src="Research.researchContract" alt="" style="width: 214px;height: 142px"
                >

                <el-upload style="width: 100%;position: relative;top:-156px;"
                           :data="{name:'contract2',index:index}"
                           ref="upload"
                           :multiple="false"
                           :show-file-list="false"
                           action="void"
                           :http-request="customUpload4"
                           :auto-upload="true">
                  <el-button type="primary" style="width: 214px;height: 142px;background: none;border:none;color: white;"></el-button>
                  <div
                      style="width: 214px;text-align: center;color: #FFFFFF;position: relative;top: 60px;left: -214px;">
                    上传劳动合同
                  </div>
                </el-upload>
              </div>

            </el-form-item>
          </el-col>
          <el-col style="margin-top: -534px;z-index: 99">
            <el-button
                style="width: 636px;height: 53px;border-radius: 10px;border:1px dotted #c9c9c9;background: #FFFFFF;color: #000000"
                @click="addjiaoyan" type="danger">添加
            </el-button>
          </el-col>
        </el-form-item>
      </el-col>
      <div style="margin-top: 20px;margin-bottom: 20px;">
        <img class="img " src="@/images/biaodan/u113.png">
      </div>
      <div class="buttons3" size="mini" @click="jichutijiao1">上一步</div>
      <div class="buttons2" size="mini" @click="jichutijiao">下一步</div>
    </el-row>
  </el-form>


  <!-- Unnamed (矩形) -->
  <div id="u58" class="ax_default label">
    <div id="u58_div" class=""></div>
    <div id="u58_text" class="text ">
      <p style="text-align:center;"><span>河北省体育局版权所有 主办：河北省体育局 </span></p>
      <p style="text-align:center;"><span>地址：河北省石家庄市中山东路372号 邮编：050011 邮箱：hebeitiyuju@163.com </span></p>
      <p style="text-align:center;"><span>网站运维电话：0311-85266259 冀ICP备：2022017224号 冀公网安备：13010202002305号 </span></p>
    </div>
  </div>
</template>

<script>
import pro from '../assets/province.json'
import cit from '../assets/city.json'
import dis from '../assets/district.json'

import {
  getimgcode,
  getcode,
  report_base,
  report_training_site,
  report_protective_measure,
  report_facilities_and_equipment,
  addManagement,
  addCoach,
  delCoach,
  delManagement,
  addResearch,
  delResearch,  addTreatment, delTreatment, filing_progress_query
} from "@/requst/api";
import {ElMessage} from "element-plus";
import Compressor from "compressorjs";

export default {
  name: 'BaoBei',
  data() {
    return {
      checked: false,
      checked1: false,
      cdtplist: new FormData(),
      jxcllist: new FormData(),
      yyzz: false,
      yyzz1: false,
      type: 1,// 进度
      baseUrl: '',//图形验证码
      getcodetitle: '获取短信验证码',
      form: {
        fridcard: '',
        frname: '',
        companyName: '',//组织名称
        quality: 1,
        businessLicensej: '',
        socialUnifiedCodej: '',
        organizationType: 0,//营利性
        highRiskSports: 0,//是否是高危
        organizer: '',////举办者
        organizerIdCard: '',//举办者身份证
        phone: '',//手机号
        code: '',//短信验证码
        registeredCapital: '',//注册资金
        personLiable: '',//责任者
        personLiableIdCard: '',//责任者身份证号
        institutionalRulesAndRegulations: '',//制度PDF

      },
      organizationArr: [{
        id: 0,
        label: '民办非企业单位'
      }, {
        id: 1,
        label: '企业单位'
      }],
      highRiskSportsArr: [{
        id: 0,
        label: '请选择'
      },
        {
          id: 1,
          label: '是'
        }, {
          id: 2,
          label: '否'
        }
      ],
      jbzxz: [
        {
          id: 1,
          label: '自然人'
        }, {
          id: 2,
          label: '企业单位'
        }
      ],
      icon: 0,
      iconv: '',
      dellist:[],
      form2: {
        reportBaseId: 0,
        province: 0,
        city: 0,
        district: 0,
        address: '',
        siteType: 0,
        certificateOfPropertyRights: '',
        totalSiteArea: '',
        reportDetailsOfTrainingPlacesList: [
          {
            trainingPrograms1: "",
            trainingPrograms: "",
            numberOfShifts: '',
            siteArea: '',
            sitePicture: ""
          }
        ],
      },
      provinceArry: {},
      cityArry: {},
      districtArry: {},
      trainingProgramsArry: [
        {name: '田径', label: '田径'},
        {name: '球类', label: '球类'},
        {name: '游泳', label: '游泳'},
        {name: '武术', label: '武术'},
        {name: '健美操', label: '健美操'},
        {name: '登山', label: '登山'},
        {name: '滑冰', label: '滑冰'},
        {name: '举重', label: '举重'},
        {name: '其他', label: '其他'},
      ],
      siteTypeArry: [
        {
          id: 0,
          label: '请选择'
        },
        {
          id: 1,
          label: '自有房屋产权'
        }, {
          id: 2,
          label: '租赁房屋'
        }],
      form3: {
        areaId: 0,
        reportBaseId: 0,
        houseSafetyAppraisal: "",
        filingOfFireAdministrativeLicense: "",
        contingencyPlan: "",
        businessPremisesInsurance: "",
        securityInstitution: "",
        renyuanbaoxian: "",
        token: "",
        reportSecurityGuardList: [
          {
            realName: '',
            idCard: "",
            img: ''
          }
        ],
        reportMedicalFirstAidSuppliesList: [
          {
            itemName: '',
            unitType: "",
            img: ''
          }
        ]

      },
      form4: {
        reportBaseId: 0,
        protectiveMeasureId: 0,
        token: "",
        reportFacilitiesAndEquipmentList: [
          {
            itemName: '',
            unitType: '',
            img: ''
          }
        ]
      },
      management: {
        "reportBaseId": 0,//编号
        "token": '',
        "managementContract": "https://www.qianhedu.com/img/zm.png",
        "managementRealName": "",//其他人员真实姓名
        "managementIdCard": "",//其他人员身份证号码
        "managementIdcardz": "https://www.qianhedu.com/img/zm.png",//身份证正面照片
        "managementIdcardf": "https://www.qianhedu.com/img/zm.png"//身份证反面照片
      },
      coachReal:
          {
            "reportBaseId": "",//编号
            "coachRealName": "",//教练真实姓名
            "coachIdCard": "",//教练身份证号码
            "coachIdCardz": "https://www.qianhedu.com/img/zm.png",//身份证正面照片
            "coachIdCardf": "https://www.qianhedu.com/img/zm.png",//身份证反面照片
            "coachProfessional": "https://www.qianhedu.com/img/zm.png",
            "coachContract": "https://www.qianhedu.com/img/zm.png",
            "token": '',
          },
      Research:
          {
            "reportBaseId": "",
            "researchRealName": "",//教练真实姓名
            "researchIdCard": "",//教练身份证号码
            "researchIdCardz": "https://www.qianhedu.com/img/zm.png",//身份证正面照片
            "researchIdCardf": "https://www.qianhedu.com/img/zm.png",//身份证反面照片
            "researchProfessional": 'https://www.qianhedu.com/img/zm.png',
            "researchContract": 'https://www.qianhedu.com/img/zm.png',
            "token": '',
          },
      Treatment: {
        "treatmentRealName": "",//教练真实姓名
        "treatmentIdCard": "",//教练身份证号码
        "treatmentIdCardz": "",//身份证正面照片
        "treatmentIdCardf": "",//身份证反面照片
        "treatmentProfessional": '',
        "treatmentContract": ""
      },
      form5: {
        management: [],
        coachReal: [],
        Research: [],
        Treatment: []
      }


    }
  },


  created() {

    this.yyzz = localStorage.getItem('yyzz') == 1 ? true : false
    this.type =  parseInt(localStorage.getItem('type')) ? parseInt(localStorage.getItem('type')) : 1
    switch (this.type) {
      case 1:
        this.form = JSON.parse(localStorage.getItem('form1')) ? JSON.parse(localStorage.getItem('form1')) : this.form
        this.getimgcode();
        break;
      case 2:
        this.form2 = JSON.parse(localStorage.getItem('form2')) ? JSON.parse(localStorage.getItem('form2')) : this.form2
        break;
      case 3:
        this.form3 = JSON.parse(localStorage.getItem('form3')) ? JSON.parse(localStorage.getItem('form3')) : this.form3
        break;
      case 4:
        this.form4 = JSON.parse(localStorage.getItem('form4')) ? JSON.parse(localStorage.getItem('form4')) : this.form4
        break;
      case 5:
        this.form5 = JSON.parse(localStorage.getItem('form5')) ? JSON.parse(localStorage.getItem('form5')) : this.form5

    }
    this.changeBoundary3(this.form.quality)
    this.provinceArry = pro
    this.cityArry = cit
    this.districtArry = dis
    this.provinceArry.push({code: 0, name: '请选择'})
    this.cityArry.push({code: 0, name: '请选择'})
    this.districtArry.push({code: 0, name: '请选择'})
  },
  methods: {
    getstr() {
      this.icon = parseInt(new Date().getTime())
      return this.icon;
    },
    getcode() {
      let _this = this
      getcode({
        phone: this.form.phone,
        icode: this.iconv,
        str: this.icon,
      }).then(res => {
        //console.log(res)
        if (res.header.status == 0) {
          ElMessage.success('获取成功')
          _this.codetitle = 59
          setInterval(function () {
            _this.codetitle = _this.codetitle - 1
          }, 1000)
        } else {
          ElMessage.error(res.header.msg)
        }
      })
    },
    changeBoundary(e) {
      this.form.organizationType = e
      localStorage.setItem('form1', JSON.stringify(this.form))
    },
    changeBoundary1(e) {
      this.form.highRiskSports = e
      localStorage.setItem('form1', JSON.stringify(this.form))
    },
    changeBoundary2(e) {
      this.form2.siteType = e
      localStorage.setItem('form2', JSON.stringify(this.form2))
    },
    changeBoundary3(e) {
      console.log(e)
      if (e == 1) {
        this.yyzz1 = false
      } else {
        this.yyzz1 = true
        this.checked = false
      }
      // this.form2.siteType = e
      // localStorage.setItem('form2', JSON.stringify(this.form2))
    },
    inputnow() {
      localStorage.setItem('form1', JSON.stringify(this.form))
      localStorage.setItem('form2', JSON.stringify(this.form2))
      localStorage.setItem('form3', JSON.stringify(this.form3))
      localStorage.setItem('form4', JSON.stringify(this.form4))
      // localStorage.setItem('form5', JSON.stringify(this.form5))
    },
    beforeUploadFile(file) {
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (!extension) {
        ElMessage.error('格式错误')
        return false
      }
    },
    beforeUploadFile1(file) {
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (!extension) {
        ElMessage.error('格式错误')
        return false
      }
    },
    /*获取图形验证码*/
    getimgcode() {
      getimgcode({
        str: this.getstr()
      }).then(res => {
        //console.log(res.data)
        this.baseUrl = 'data:image/png;base64,' + res.data
        // this.baseUrl = 'data:image/png;base64,R0lGODlhggAwAPcAAAAAAAEBAQICAgMDAwQEBAUFBQYGBgcHBwgICAkJCQoKCgsLCwwMDA0NDQ4ODg8PDxAQEBERERISEhMTExQUFBUVFRYWFhcXFxgYGBkZGRoaGhsbGxwcHB0dHR4eHh8fHyAgICEhISIiIiMjIyQkJCUlJSYmJicnJygoKCkpKSoqKisrKywsLC0tLS4uLi8vLzAwMDI4MDQ/MDVGLzZLLzdQLzhTLjhWLjlYLjlZLjpaLjpaLzpZLztYMDtXMjxUMz1SNj5POEBLO0FHP0REREVFRUZGRkdHR0hISElJSUpKSktLS0xMTE1NTU5PUk9RWE9TXVBVYVBWZVFXaFFYa1FZblFacFFaclFadFFbdVFbdlFbdlFcd1Fcd1Jcd1JcdlNddlRddVVedFZec1hfcllgcVthcF5jb2BkbmNmbWdoa2tra2xsbG1tbW5ubm9vb3BwcHFxcXJycnNzc3R0dHV1dXZ2dnd3d3h4eHl5eXp6ent7e3x8fH19fX5+fn9/f4CAgIGBgYKDhYSFiYWHjYeJkIiKk4mLlomMmIqNmoqNm4uOnYuOnouPn4uPn4uPoIyQoIyQoIyQoI2QoI2RoI6RoI6Sn4+Sn5CTn5KUn5OVnpWXnpeYnpmanpycnp+fn6CgoKGhoaKioqOjo6ikpa6kp7Klqbalq7qmrL2mrr+mrsGmr8OmsMSmsMWmsMWmscaossertMmttsqwuMu0us25vc6+wdDFxdPMytbV0OLm4Ovy6/T49Pr8+v39/f7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v///yH/C05FVFNDQVBFMi4wAwEAAAAh+QQACgAAACwAAAAAggAwAAAI/gD/CRxIkBeuVKQ8TVrIcJSpWrt8EZxIsaLFixgzatzIcaMuU5NEpbKlSxevk7t04WpFatKoWbw6ypxJs6bNgbxKTVKlS2JGXrVaxup1s6jRox13gSq1a6YvXJ5IxURKlSIvW7mqduwlKpZPmrxMiSKqlSqvW64glt2YytTXmr1KtVpr1KArWk3papyk66guT2/1cuyFy9WsvoJ/TpoqMDBHXosTD871Spaub5L3IhaYy1Quxh4BZ8boizKsnqM1tv3KK1cpUKc+a4w7NzVFX7pkvcrl2DZFrrEo7spFKtQtXWStik3u+1vuV7iY+8aotBRogf523Rol6njyp6Ck/k4XqGuWq+h+SelpsmOHED+3jubciXoi7u2jjgedtCplrv+5mCTZLrScx9gutnBixxpr0OEJLhvJocOEFFK4Rl5FfRSSKiSZhJIut9gyCij53QLgif8hN5NBtHSCCSab1LKZQLvU4ootoE1yxo488hgZRhUGOaEavYGFyykJMdTQQ7rkcsomnZRiIooBYsbRLJJkqaWW4l2VFoYD9Sjmjo9YadGEdNzSVGl8UFgKUr3wQpYvJ8lZ0S2mhOJJKZ/x0uR/YGa05aBZflKYWhXtWAkuMTnHCY+2YPTGjAMBMmEbddXiyaZ4aaRia6/F9ielGGU5i2zfEPgIH3KUQipB/nxV5MmOk9Sky4Q+ZPgJLSbV6ElWMg1HyiegoALsRkxNRFghdRxCik267IhpTRTe9NexnHnyakbZkbLJJt7N1AtlsuDyiCSY3LRjGjX5gutNUt5JSpEYffPfKvgdR+9AuMFymkRZWmLTNzu+UVMuExpsayjXCdRLKNg+luI/vYAYCilq+lPRL8/lQtY3WWYCLa01bTLhszXVEqlFt9BC059gVnzKUrmA+Rx6A+2S5Zs1lbLjyjLpsoMOQDTM0Sjb/qOLKOIC2FtrptBc3nnS/XNLlhDStMsaZ8BRdUa9qDEhzzT14kmgBO3iydcWOQfoT7eQQnPDu2AiSSZsk/bI/s80talDHTfx4onRAglOeEWjZlTjjU3KHe4/voySZcQcPXqGyDOZrIMah8929kVq5z3RqPR6ieg/2cVtnC60ZOkyTT6f8Yjosk7YBNozIX3R0hwN9x/bdnX6T50+3TeIHYJgQntFs5DZee063H6Uyhe1vJHvHldEmGG67IILLaB8+y3GfV1tyCBRZXzljno8T5Hm0vvFsPaiUE7Rn9kri0tlJt0SHi7d40VKcFGLUDwCEZLohJxAFJ6aZSR2j3AfQXzhhyHhzibxokjc9uWPUUmnNPzDzSh4dZFa0IEMiAAN1OZ2m1nJToI4WcOE1gBDjlxrIrnQFmlIN0FdwGI3/hLRhXHY5otaZGkTI2wYqEDhmalAxnnBEtvmPkEK+1lrV73SlBUdNiozOUc3+etFfi7CC1JkSSq8GEUtijScUOVib5fbV0WaMKTP5GIUW6wJUDblCeFdBEAzmhrOODMK4ElOErTwyS4ghpHUlaELY8AbTYREyQkdJU7L+weVbnGKUqgCRQKhxRY7kSWgCSRuGzmDGcjQBUiaYUw7OlMlheSbE90CFaVIxZRORDFQXPAfhNKSIsZwrixdpEdmGEMryfDKHslylhWqJYBYgYpdgpIXmzhcMLP0CGJq6ZhjKoMYltlMi6SRVKpAxXjK5suLbFMSwyymJMDiJBbejxRmvRqILgq5zpmIkiaolE9nmCibgdxSe6RIWj8rcsdM5oyRVWkjbLKnivhUpJoL3coYH6NGOdpEO8WJmxUPmlEbGseju0hiYu4Diu7UR59kK6mnRvjLs4DiFh5FyjfqdwtR5GcXGlPaKGTaEZuSAoC7EKBKCphQ2/BCFDGp2C0uVrNdjIWoSfle+MRHvpxW5akqrGcpQqFQrJrzJF5dC1gr0hpQ5NGscMUJVM0517jala6Es6pD71rSnV5wnzMJCAAh+QQACgAAACwAAAAAggAwAIcAAAABAQECAgIDAwMEBAQFBQUGBgYHBwcICAgJCQkKCgoLCwsMDAwNDQ0ODg4PDw8QEBARERESEhITExMUFBQVFRUWFhYXFxcYGBgZGRkaGhobGxscHBwdHR0eHh4fHx8gICAhISEiIiIjIyMkJCQlJSUmJiYnJycoKCgpKSkqKiorKyssLCwtLS0uLi4vLy8wMDAxMTEyMjIzMzM0NDQ2Njw4OEQ6Oks8O1I9PFg+Pl0/PmJAP2ZBQGlBQGxBQW9CQXBCQXJCQnNDQnNDQnNDQnNDQ3JEQ3FEQ29FRG1FRWtGRWlHRmZISGNKSWBLS11NTVlPT1VSUlJTU1NUVFRVVVVWVlZXV1dYWFhZWVlaWlpbW1tcXFxdXV1eXl5fX19gYGBhYWFiYmJjY2NkZGRlZWVmZmZnZ2doaGhpaWlqampra2tsbGxtbW1ubm5vb29wcHBxcXFycnJzc3N0dHR1dXV2dnZ3d3d4eHh5eXl6enp7e3t8fHx9fX1+fn5/f3+AgICBgYGCgoKDg4OEhISFhYWGhoaHh4eIiIiJiYmKioqLi4uMjIyNjY2Ojo6Pj4+QkJCRkZGSkpKTk5OUlJSVlZWXl5eZmpmanJqcnpudoJyeoZ2fop6fo56gpJ+gpJ+gpaChpaChpaChpaChpqGipqGjpqKjp6Okp6SlqKWnqaaoqqiqq6qtra2urq6vr6+wsLCxsbG2tbW6ubjAv73GxMHKyMXOy8jRzsrT0MzV0s3X1M/Y1c/Z1dDa1tHb19Lb2NLc2NPc2NPc2dTc2dTc2dTd2dXd2tbd2tbd2tfb3NrZ3d3X3uDW3uLU3+TT4ObS4OfS4OjS4enS4enZ5u3f6vDm7/Ts8/fx9vn1+fr4+vz6/P38/f7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v4I/gD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsaPHjyBDihxJsqRJbtq4mVyJENs1bCW1UYP27Bk1bSxZWqPVKZJPTbKohcwWLZo1bNaKwsw5chutSat2WbtmrRisSa6seXRXVKVArtG8Mv2ojRWmZQetrbKElqO1Z0sHZoOmdexHWZquKXwqdOO0vgWpTbMbERswW7JgwZJlSxlBZZOqMaSFKS5Go2mjER6IrVoyZMWUVctGsFar06hR0yL9T1UthtVmofnypcuXO50AR9wG9yC2Z9sIZ1NWrLjx4nX/pV5+mpY7apQsG4TGJ0uWJDqOWLe+ZRZEaq34/hwJQj6Lo2YDtT3DORYb6OPw656ulYy0u2u2UCOb5Wphqe1Z7LAEgNbh0lAzX5Cn4IJBsCLQb8Exlc17y1yj0n3EFRdcLdIJlF8rtJByy0KOZJEGJrfI4mA1rGxhXSANRcLgjEG8lpRdGUpWEDcZJufbaVcxs1Aht7gjkDKWeEWLdV80REcQRxRCizV/RWOJgmX8I1h7xbVl0DXFCanQaatE4iND10Si1z/bWNdFQ2rQItZbMLmi4FxnmkRNcWsaxE1xyCjkzmmsqAlRmmu6Y90bE4HFzTYKdjVWMsUZiZBxCl1z2ixmHmroP8tYdwlFRBlFnhHRdGgSpgkBqlAu/qcBM4mYDi1DiVeTWIceRTLZGcQd7I1lXIR+utoSLK3Esg0puUBUyyoChZrFIxjpQd6uOBan45fFOXYQN7ScFugsskCkCi3/WJNGFmf0SdEt5Nmx2T/VGFcNNka6k801zBinG0EfvgYqJsEuVI2Z1sSRhRjYCrSNNpY2VM14Q+SZ0zaUwqdxMRbDCmKE3GDyi0OzwFINGwvTOhA1ueTSjDPOQBPNX9RUMxU22WxjzXhBNCxcxhovkzFrBOlyWixTeVVLJwUjtEwktJDBrs8CaUOVNdUINk000DjTDDMt5zLLEOTFUtRfNt+cEkvcWLMMaMgsM9o2oHk7EDe1JILI/h512GGHHpK4Eo0mtiyEjSaQuFiHxQ6hZAt5Q9AiWFHPeB12y8y8/MzMaFszVdMfVcUxQdEQkschmERzzerN1GKJHotIsktC2HTiBhZZMEI0Ra2QZ8W2Bm2TjUtYUzN515bn8q9H2sAdYTaX3JHIubtzJkshkhRu0DKQZIF7Kxdp0wd5c6gakTvaEPsRN8sgJ9A1iQxyCoigE3TNI5Z8cgs1VPWySh5JwEIavESRaFiBPKOaV+P6VYy2ZMMQi1BFK2ohloRkIxOO6IlPLBEH7RTCXROJBXmOMKKLuONh6vMINjKUjAipohCraIWBHKINR5hiG9dYxhqysIVYXOQa/nYgjxq04g6UDG91nquGEo03ja0V5YlQjMbyKOI5++yrfd2KkDXwoAnmeBF8BKkGHqohLTlQTSAo0QY2iJfErDFRFkQgzyKiSMc6NtF4NUvb6rBRv4nsaWPFYIZYYlGJL3pRjUi0BixooYkjOPIIRhCCJCc5ySPUEYqyGGEtlOi5m/FxbZvJEHyUIZ1CmMaQy6FGHfsgSSM88pWvVEQ2QGmQS9CIRkOYFzPghgxmWKN6bLID4w6CQksB8QwESuZ2TLGQIN6SQXRQYEOACMJD2aGaFOHZMxU0CWkyZBvCrAgQ++jNzZiyItEYRDnXKRBCRqQb2OjGPy7RH3aWc4vAqkvINZKBC1v4cxdjtOc6VeEI8wmkG8mwRTCScRRrNIITtjCGQQXKkmwkwhLAFEg2fIGLbWWDE4XYlzFukU+KjuUai0hENbWhC1zE5RqO+OBAEjpFk1b0EniIhWWScYs1YUMWeriEdHiKTZuyJBqJwAMlamEU5VHDdXpIRFgOkgxfRMyoY+FGNWRRCT747W+SaAU1KliQbNzijFiVkPKukcKEJGMXV00rQgICACH5BAAKAAAALAAAAACCADAAhwAAAAEBAQICAgMDAwQEBAUFBQYGBgcHBwgICAkJCQoKCgsLCwwMDA0NDQ4ODg8PDxAQEBESFhMUGxQWIRUYJhYaKhYbLhccMhgdNRgeOBgfOxgfPRkgPxkgQBkhQRkhQhkhQxkhRBkiRBkiRBoiRBoiQxoiQxsjQhwjQhwkQR0kQB8lPyAmPSInPCMoOyUpOigrOCotNy0vNjAxNTQ0NDU1NTY2Njc3Nzg4ODk5OTo6Ojs7Ozw8PD09PT4+Pj8/P0BAQEFBQUJCQkNDQ0REREVFRUZGRkdHR0hISElJSUpKSktLS0xMTE1NTU5OTk9PT1BQUFFRUVJSUlNTU1RUVFVVVVZWVldXV1hYWFlZWVpaWltbW1xcXF1dXV5eXl9fX2BgYGFhYWJiYmNjY2RkZGVlZWZmZmdnZ2hoaGlpaWpqamtra2xsbG1tbW5ubm9vb3BwcHFxcXJycnNzc3R0dHV1dXZ2dnd3d3h4eHl5eXp6ent7e3x8fH19fX+CeYGGdoKKc4SOcIWRbYaUa4eWaYeXZ4iZZoiaZYiaZYmbZYmbZYmbZombaIqaaouabYuZcIyYdY2XeY+Xf5CWhZKVjZWVlZaWlpeXl5iYmJmZmZqampubm5ycnJ2dnaCfnqSioKeloamno6yppK6qpLCspbKtprOuprSvp7Wvp7i3pbq+pL3Eor/KocDQoMjZqs/gs9Tlu9npwt3syePw0+ny3u715/L27vT38fb49fj59/n6+fv7+vv8+/z9/P39/f3+/f7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v///wj+AP8JHEiwoMGDCBMqXMiwocOHECMq5IVrl8SLGDNq3ChQlyxXq1bJysWxpMmTGG+5elULV61Xq2yhnEmzpkBer2J9G/gt1iteNoMKxSjrZ8Fvr2QN1ajLllNdSzHmWkXrYK1VJKM6pJUKFKVJYMFS6pRqltatr3YaRFr1rMJZlSaRnUXLqa1as2CNmkRJqduEsvwelBXr78FdqCahqrWwVirFFg0XdNX2IK1VkguiosTYYS1KqDITXNXZ6iq1mXNNMgtx1iRcov9NvfVSlSNFuB+xmoU1tq1JMiH+Dl6zFixVqVKtikVcoCxVj3BLn64IFOzGndTkWLFChptUJXf+Uaq8dRJUmrleJV+/vvBAWI8SUZ+eKBCshWFG6N+/P0tzjKlQct1CuuAlySev5ERLVhzlghx7EN7XkSKFKLJccLW0oggigUiyEH8g6heFLxvlkskntyiEi0+vTCJJgjC+QgtQG62y3iwkfWPcjQMposqABL1iiCCKfDjCGKcw5ssrbOz3CUe4bDJJLOcZRMsrpfzxIoytdNmlK7KkeJFjqfxo0CzJqaJWLCsd5MsggxSpUBfkDQSHfluU5IssX40iS11O0SKLJ4H8kUotQOXiypeuwJIXmL9IBEtyrBlkYyptzeIKZQcJUggjGNGiHwsn+UILKnGFNUklnsgS2T/+vDTay0sJCkSLK+5BtB6DBXGVioS3rAKLKzQOFEsgiWCGkX4q2ISLLbeQeKYrvfyDVK0C1cKprsklhEtyrwyUE64FQUJknQ/5ot8Lkr3C2rUSOhcut6mgdtR6A12mKXGxCGKIKhm9ol8XhsXa2S0JkmcLsRA9WJpB+BoLS4L+/FOLIXGKedEf+nFimKJZXfkKkCBDFEtyq1RJ0DcRC7TLsK3QNaQi6D5EywojvACkVgb/g7C7BalUbEO2rKfKggL5UstzLd80CyusFFJhpRLpsoR+TzqkS7UmuTLLy6/A8qpAs8wLkSwQpt30QLMgMrVGTY5QBkSvcALKKaooaAv+1xEVNfHIBcVK9UNoqv0ryga9ooh8g0fkh35M7LwQLrT4pMopoHCi+d15x1IX3whluJLGAvnjU6QXrXipcmGSGS+squCWtyuoS1SJfj/8d1EvtlT+yuWZb4633lzfAkuXdfLC5sMmFV5pLbcp0so/uoB50e0j+MA8Srz7DrzmdoviiSmqLCpLLbncoilLNamXSnCK41bprZIv9PgIQmy/VPermOLJJ58A3ydAoYpVUGZvMyETZnARu+qQzh/Yaggv3KCfJehOK7lgUVu6N6zvCa9zn8OILh5Ei1lIxxUHWVjNDGKLLOgHCxeMCq1gQbqDdM9ymANf6i61ChMqwhHlK/wHm4ZmlSPoxwwqO0svypYUIj6kewwhDYmUhrY04UJD88kiInKFkBzopw+ZMV6C9EcTw5VJJg3MInUk4YoYCiREcNSPTX4Wi/rVxHCwyIoas8gKiiUkjnC0ichiREgYvW4j7gPXLOzIEFxs6yCADJFNmFjIQgomNoNxRRIx+Z5KVjKImPxFozhJyuJcspSoTKUqV8nKVrrylZnhhS50UTFY2lIgLilhYGQxi1m05Jat1IWgfGmLWeqCNrP4E6+AyUm80AIXtTQI5c4XTWaKRlA1RIj6aFFNa/4FL4w0SC58acuAAAAh+QQACgAAACwAAAAAggAwAIcAAAABAQECAgIDAwMEBAQFBQUGBgYHBwcICAgJCQkKCgoLCwsMDAwNDQ0ODg4PDw8QEBARERESEhITExMUFBQVFRUWFhYXFxcYGBgZGRkaGhobGxscHBwdHR0eHh4fHx8gICAhISEiIiIjIyMkJCQlJSUmJiYnJycoKCgpKSkqKiorKyssLCwtLS0uLi4vLy8wMDAxMTEyMjIzMzM0NDQ1NTU2NjY3Nzc4ODg5OTk6Ojo7Ozs8PDw9PT0+Pj4/Pz9AQEBBQUFCQkJDQ0NERERFRUVGRkZHR0dISEhJSUlKSkpLS0tMTExNTU1OTk5PT09QUFBRUVFSUlJTU1NUVFRVVVVWVlZXV1dYWFhZWVlaWlpbW1tcXFxdXV1eXl5fX19gYGBhYWFiYmJjY2NkZGRlZWVmZmZnZ2doaGhpaWlqampra2tsbGxtbW1ubm5vb29wcHBxcXFycnJzc3N0dHR1dXV2dnZ3d3d4eHh5eXl6enp7e3t8fHx9fX2Af32DgX6Gg36JhX+Lhn+NiH+PiX+Rin+Si3+Ti36UjH6VjH6WjX6WjX6XjX6XjX6Xjn6Yjn6Yjn+Yjn+YjoCYlIOZmIaZnImaoIuao42apY+bp5CbqZGbqpKbq5Ocq5Scq5adrJifrJmhrJujrJ2mrZ+praKtrqWyr6m0sKq1saq3squ4s6u5tKy7trC9t7S/uLfAubrCub3DusDDusLEu8TFu8XFu8fTy9Xl4efw7vH39vj7+vv9/f3+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7///8I/gD/CRxIsKDBgwgH6rJVq6GtXAkjSpxIsaLFixgL5mp4KxcuhrcyihxJsiRJW7Z2EbxVC5fJlzBjkmQJsSBDXTJz6tw5sFstWwd11QrJs6jRkbhq1TTIEufRp1Aj3gKKUCjRqFizooy4NatXqEOl1vpK1mjLiEm7lV0rc+PSg25jLnzLdicuVZnYgAGDBo2riHFh6iJF1ONUlCg7SvzoahQoUKJeXS17aYvly5cBuYSrVGapjocRi7a1+WCrTqhTp2ZFF+atVZQeSbrkarJAzLgt+1FrMK1MWbZCjxZduqDq46hV8YaZS9Sj59Cf/yVo+RIrl91uqbnM6iDLi7py/jk9+PPwLVxOc4W2PRB1K8XdcLlKTfVlrkrR8z9aRTAQe1t7WAbIQV1NlIstrKyyCi3FDQQSLssR9FGBBV130CuodQcTKM9R8pBAt6QCXX0IsWRZGAZZRREurUjmEYL/yRJRN4hhhAtqoLjWYYP/xNKhSgklZZkXTNUyXkSxxHLka7bdUsqMNWKE2icwrfIciQRx+Ah7BPlk2RgFqTjRaw3WQooqkowFIilHapQYRt2gFgpMsT3SmkC2PKdhQrRYFohNRlJkCy02SYKgLZLAotKBba6E0p1oZQgTdEE+N2dEnViGykpnUfQKibmk+c+gtxhq4JsY0YIaliNRmtBz/pNIBcYWXwz1YlgVrTIZLWz+c0t3sUjCI0ELodToYqB0EsqxGVnyHJcCuRpUHpapwpBDkMK1SnGiqJnLKuGBImNViGWL0C6mrBoTK89dcucu0hqkiWWYDJRLhBR9u1Spm+n7jyyhAOnmoxnN10krMuECXSUf/rPLLbDg9xxCmW6xh7kGbjsQr/aC66sk7B1IsEC8VKRqJ6YwOxIs+rUcq0GlWBbHsBd1o+tAr0z3Dy57kkKohIjhpF5wgqJGCsYi5dnyI+w+0olBpFgGB80YSTaQKT+PCgvO/An0cGK6TFUe0rYYjTRS80kiGyiv4HLLc123Z9kcVGNUYCj11eag/igCiYwYR3UTdHIpZ+ukdH27cGJZHoFf9KtTIIO4yr6S7MyQLA7hUjJFu2CIcuEG4lJ4KM/1C4hlf4BOkS7v7SzsP7q4QmKptsiSCizBqQwXKxmqntAtk8zhBhymStWuQLjcQa/uI/3qkbDd0PLKeAeucgruzMNVinsCl/QKHKOQZgspbqSSUC7OPkIVG5Y9zVP074H8SisQhT1oK6N0JtIoqMUS0y1wwJItAniQGz3Hff/IjQItU5JdIGgVrHiI2IbCkjQNZzgJQY4GUWORSYziIKSQBChuoZKHuUJtj6BEaRaowJfgAmTXIo1aKnjB0UDrHxvUYEVyMQdWjQoOyIxYGiUmw8LcmMRtmete7QxVQ8TcMIfIqQgu3DCsKSaiZazxytB+sgofjopvdSEID304wFJMokOnIA1ZpqKYUqjJILCIWxgF4kEQVm6O/9icQFyhs4KYwn94BBEBCTJAL4ZRFqYoYOQCKZDvkUJ8pICD+Ri5Ekk0ClHdCyTwhEc8Q85RF8UjiCkQRkkxiq6UB1nFKwpSqhui8pUgksRbTnEKWNryXKPYGp4WecteDoR2HxGVL4cJolBIQhSeJOYrc5FJZToTlQEBACH5BAAKAAAALAAAAACCADAAhwAAAAEBAQICAgMDAwQEBAUFBQYGBgcHBwgICAkJCQoKCgsLCwwMDA0NDQ4ODg8PDxAQEBERERISEhMTExQUFBUVFRYWFhcXFxgYGBkZGRoaGhsbGxwcHB0dHR4eHh8fHyAgICEhISIiIiMjIyQkJCUlJSYmJicnJygoKCkpKSoqKisrKywsLC0tLS4uLi8vLzAwMDExMTIyMjMzMzQ0NDU1NTY2Njc3Nzg4ODk5OTo6Ojs7Ozw8PD09PT4+Pj8/P0BAQEFBQUJCQkNDQ0REREVFRUZGRkdHR0hISElJSUpKSktLS0xMTE1NTU5OTk9PT1BQUFNXUVVfU1hlVFlqVVtuVlxyVl10V193V2B4V2F5V2J5VmN5VmR4VmV3Vmd1VmhzVWtxVW1uVHBqVHNnU3RnU3RnU3RnU3VoU3VoU3VoVHVoVHVoVXVpVnVpV3VqWXVqWnVrXHVsX3VtYXVvZHZwaHZya3d0b3h2dHl5eXp6ent7e3x8fH19fX5+fn9/f4KChYWFi4iIkYuKlo2Mm4+On5CPo5KQppSSqZWTq5aUrZeVrpiWr5iWsJmWsJmXsJqXsJqXr5uYrpyYrZyZrJ2Zqp6aqKCbpqGcpKOdoaSenqafm6igl6qhk6qhk6uhk6uhk6uhk6uik6uik6uilKuilKuilKuilKuila6mm7CqobKtp7WxrLezsbi2tbq5ubu7vb28wL6+wr+/xL/AxsHDycPFy8TIzsXK0MbM0cjO08nQ1crS1szV2M7Y2tDb3Nji4uTs6/D19ff6+vv9/P3+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v///wj+AP8JHEiwoMGDCBMqXMiwocOHECNKnEixosWLGDNq3Mixo8ePIEOKHEmypMmTKFOqXMmypcuXMGPKnEmzpk2YwWSNukOHzh1Ov26WHAYs2EBhv2BlokQJUyxgDUdxmUqV6ihhHnl1mpOmDaBUUEcOCwbMF66zvoANI1gs2K9fWP+5ekS3bt1WaxVW3TtVkL+NwgalGUx4cKqQSM8qXozL6D+kv4IVG2i3Mt1V4vRyGeULqz9gqKja0iiMTuHTaTqBBMa4deOyagvSdQUMq7hgsOqGRTjKcUFOU0dpFJxGjizbvzoRnvWR9a6iecfiuhULFtyDreIWjEW3VURiY6f+0snIa7Ac3wNZDZ5DzCPczAaB0YU1GaIwupQeAmM1qv+WLXNkpFwazB0kyGC7mERMWY/YgstEdEnS0DD89SLMMML8t4V2FcUxGIcE3TKYcCS5BddZvUgkDn4MEaOKKtoBM5UdvV1EWELBDDbISMKUFQwxwpy120PBdMdQLqrkJdAqU73yy1UWEQafQeIM9kZIxASTVl6s4QJiQ7jQFZRCwUA5UDB0cFHHWraoMqVEdQyWIkKDrQGSib4FicuQDglDySOUKInQK7kQREwgU432DzGj8AkRKoMB8uWiN3ZElC8/DjTMLrjsImhDxaxCl6MFCWOmQKFtRhAwo7wJETD+hNVhS1zE9MKKaWnYuVGWaXE4TC+46DLpQrk9AstCC6pCEJNcSGpojRSphxpqbgD2Fnr//BrssAqF+cgq7RlkTI+76GKuLuUK8p8WrsRiCy+x1cKLRa9MO9iAgWR0KTDhHsXpLtwmtAtdmXwqkDC79BLMhazYMkssgWyhBR4Lu5WLLLH48gsrFwWjSiBtdDUIK27de1FbvRoUDFoGMzTwI5lMGswuwRgj0DCPxPILs3WMOdCCtMSiSr8czTLYKxZBhu0/xXTJr0TerjIpwtoJM8sjwQDHRSAzf0mML7DYUh9HxJE6IWwGD2NWYxIVw923Lf/zy27DzHLLKIMEhxX+MD4TNMwpsuhCNEa/RDpRW2/JrEunASM0TCvdxU2MsAPpYkswWwQXrjCCGzRMbzoD5sdgitp37UELnvXL4A0JI6qxY3uuS17CxBLMHZkrq+nsKrcaTCyNOxRMIIPlKxFZLSN81tIOZUJX6QgZQ/k/vBTKxX98gbGXQPsJVEvfDg3SS3tfqxJyccxXpKeFFVnmPl1yh0ULVNdnvpcX2//zLvcFQmRvGnMwW0VW5prWJCgh73PfP2Y2jGHAAiv128sX+LIoaAkDFqxbiL1OtZEuFXAxAvxHAi3DPbg88GBmIsbcbFYQVsHngsErSCfeMJg4dIJkIOHUB0G4K1/s4oT+AiHUY3zhC9YxajcXzKBQFASMWOTiQmOZhS908TSDIGlKwOjfEh8Cno3ooha9OBcuYJG+J3Hoe1uMiC84sYlVsOIVtugFMIpyob/0yXbgIYaLYFSQyUFLIL+LYRo1FQyy+CIXr2jFKjbBiUZuQhWscIW85rawYcTuH5brF4U4cyGk9IdDtQPfICsCpELyTReyUKQmGtlISLpiFrrohStksbBw7ac/o1DF6ggSDFgqcZQcKSVZfsGLWbiCFatkpSZW0QpZ5AJehRRGe5rmxF8C0yTCqAUc+caLWhxTFYx0pCYgeYu0FDJu1yxR0HJBR2EIQ0vaNNYtbPEKViwSKBctwRA605kQXlEHFgCNhbxi4zlrMuQXtJAFLXbJz7a5U5oiQWhtgmGLzjXUJAEBAA=='
      })
    },
    //上传文件
    customUpload(file) {
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: '资源正在上传，请耐心等候……',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: document.querySelector('#table')//loadin覆盖的dom元素节点
      });
      console.log(file.file)
      let _this = this
      let wz = file.file.name.split('.')[1];
      if (wz == 'jpg' || wz == 'png') {
        new Compressor(file.file, {
          quality: 0.1,
          success(result) {
            let filess = new File([result], file.file.name, {type: file.file.type})
            console.log(result)
            var FormDatas = new FormData();
            FormDatas.append('fileName', filess);
            _this.$http.post('/education_web_means/api/reportUploadImg', FormDatas, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then((response) => {
              loading.close();
              let str = response.data.url
              if (file.filename == 'yyzz') {
                _this.form.businessLicense = str
              } else if (file.filename == 'organizerIdCardz') {
                _this.form.organizerIdCardz = str
              } else if (file.filename == 'organizerIdCardf') {
                _this.form.organizerIdCardf = str
              } else if (file.filename == 'personLiableIdCardz') {
                _this.form.personLiableIdCardz = str
              } else if (file.filename == 'personLiableIdCardf') {
                _this.form.personLiableIdCardf = str
              } else if (file.filename == 'crimej') {
                _this.form.crimej = str
              } else if (file.filename == 'crimez') {
                _this.form.crimez = str
              } else if (file.filename == 'yyzz1') {
                _this.form.businessLicensej = str
              } else {
                _this.form.institutionalRulesAndRegulations = str
              }
              localStorage.setItem('form1', JSON.stringify(_this.form))
            }).catch(e => {
              loading.close();
              ElMessage.error('上传失败')
              console.log(e)
            })
          },
          error(err) {
            //错误处理
            console.log(err.message)
          }
        })
      } else {
        let FormDatas = new FormData();
        FormDatas.append('fileName', file.file);
        _this.$http.post('/education_web_means/api/reportUploadImg', FormDatas, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((response) => {
          loading.close();
          let str = response.data.url
          if (file.filename == 'yyzz') {
            _this.form.businessLicense = str
          } else if (file.filename == 'organizerIdCardz') {
            _this.form.organizerIdCardz = str
          } else if (file.filename == 'organizerIdCardf') {
            _this.form.organizerIdCardf = str
          } else if (file.filename == 'personLiableIdCardz') {
            _this.form.personLiableIdCardz = str
          } else if (file.filename == 'personLiableIdCardf') {
            _this.form.personLiableIdCardf = str
          } else if (file.filename == 'crimej') {
            _this.form.crimej = str
          } else if (file.filename == 'crimez') {
            _this.form.crimez = str
          } else if (file.filename == 'yyzz1') {
            _this.form.businessLicensej = str
          } else {
            _this.form.institutionalRulesAndRegulations = str
          }
          localStorage.setItem('form1', JSON.stringify(_this.form))
        }).catch(e => {
          loading.close();
          ElMessage.error('上传失败')
          console.log(e)
        })
      }
    },
    customUploads(file) {
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: '资源正在上传，请耐心等候……',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: document.querySelector('#table')//loadin覆盖的dom元素节点
      });
      console.log(file.file)
      let _this = this
      let wz = file.file.name.split('.')[1];
      if (wz == 'jpg' || wz == 'png') {
        new Compressor(file.file, {
          quality: 0.1,
          success(result) {
            let filess = new File([result], file.file.name, {type: file.file.type})
            console.log(result)
            var FormDatas = new FormData();
            FormDatas.append('fileName', filess);
            _this.$http.post('/education_web_means/api/reportUploadImg', FormDatas, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then((response) => {
              loading.close();
              let str = response.data.url
              if (file.filename == 'certificate') {
                _this.form.certificate = str
              }
              if (file.filename == 'notice') {
                _this.form.notice = str
              }
              if (file.filename == 'credit') {
                _this.form.credit = str
              }
              if (file.filename == 'yylicense') {
                _this.form.yylicense = str
              }
              if (file.filename == 'yycivilnon') {
                _this.form.yycivilnon = str
              }
              if (file.filename == 'fridcardz') {
                _this.form.fridcardz = str
              }
              if (file.filename == 'fridcardf') {
                _this.form.fridcardf = str
              }
              if (file.filename == 'attorney') {
                _this.form.attorney = str
              }
              if (file.filename == 'clientidcardz') {
                _this.form.clientidcardz = str
              }
              if (file.filename == 'clientidcardf') {
                _this.form.clientidcardf = str
              }
              localStorage.setItem('form1', JSON.stringify(_this.form))
            }).catch(e => {
              loading.close();
              ElMessage.error('上传失败')
              console.log(e)
            })
          },
          error(err) {
            //错误处理
            console.log(err.message)
          }
        })
      } else {
        let FormDatas = new FormData();
        FormDatas.append('fileName', file.file);
        _this.$http.post('/education_web_means/api/reportUploadImg', FormDatas, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((response) => {
          loading.close();
          let str = response.data.url
          if (file.filename == 'certificate') {
            _this.form.certificate = str
          }
          if (file.filename == 'notice') {
            _this.form.notice = str
          }
          if (file.filename == 'credit') {
            _this.form.credit = str
          }
          if (file.filename == 'yylicense') {
            _this.form.yylicense = str
          }
          if (file.filename == 'yycivilnon') {
            _this.form.yycivilnon = str
          }
          if (file.filename == 'fridcardz') {
            _this.form.fridcardz = str
          }
          if (file.filename == 'fridcardf') {
            _this.form.fridcardf = str
          }
          if (file.filename == 'attorney') {
            _this.form.attorney = str
          }
          if (file.filename == 'clientidcardz') {
            _this.form.clientidcardz = str
          }
          if (file.filename == 'clientidcardf') {
            _this.form.clientidcardf = str
          }
          localStorage.setItem('form1', JSON.stringify(_this.form))
        }).catch(e => {
          loading.close();
          ElMessage.error('上传失败')
          console.log(e)
        })
      }

    },
    customUpload1(file) {
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: '资源正在上传，请耐心等候……',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: document.querySelector('#table')//loadin覆盖的dom元素节点
      });
      let _this = this
      let wz = file.file.name.split('.')[1];
      if (wz == 'jpg' || wz == 'png') {
        new Compressor(file.file, {
          quality: 0.1,
          success(result) {
            let filess = new File([result], file.file.name, {type: file.file.type})
            console.log(result)
            var FormDatas = new FormData();
            FormDatas.append('fileName', filess);
            _this.$http.post('/education_web_means/api/reportUploadImg', FormDatas, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then((response) => {
              loading.close();
              let str = response.data.url
              if (file.filename === 'certificateOfPropertyRights') {
                _this.form2.certificateOfPropertyRights = str
                localStorage.setItem('form2', JSON.stringify(_this.form2))
              }
              if (file.filename === 'list') {
                if (file.data) {
                  _this.form2.reportDetailsOfTrainingPlacesList[file.data.index].sitePicture = str
                  localStorage.setItem('form2', JSON.stringify(_this.form2))
                }
              }
            }).catch(e => {
              loading.close();
              ElMessage.error('上传失败')
              console.log(e)
            })
          },
          error(err) {
            //错误处理
            console.log(err.message)
          }
        })
      } else {
        let FormDatas = new FormData();
        FormDatas.append('fileName', file.file);
        _this.$http.post('/education_web_means/api/reportUploadImg', FormDatas, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((response) => {
          loading.close();
          let str = response.data.url
          if (file.filename === 'certificateOfPropertyRights') {
            _this.form2.certificateOfPropertyRights = str
            localStorage.setItem('form2', JSON.stringify(_this.form2))
          }
          if (file.filename === 'list') {
            if (file.data) {
              _this.form2.reportDetailsOfTrainingPlacesList[file.data.index].sitePicture = str
              localStorage.setItem('form2', JSON.stringify(_this.form2))
            }
          }
        }).catch(e => {
          loading.close();
          ElMessage.error('上传失败')
          console.log(e)
        })
      }
    },
    customUpload12(file) {
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: '资源正在上传，请耐心等候……',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: document.querySelector('#table')//loadin覆盖的dom元素节点
      });
      let _this = this
      let wz = file.file.name.split('.')[1];
      if (wz == 'jpg' || wz == 'png') {
        new Compressor(file.file, {
          quality: 0.1,
          success(result) {
            let filess = new File([result], file.file.name, {type: file.file.type})
            console.log(result)
            var FormDatas = new FormData();
            FormDatas.append('fileName', filess);
            _this.$http.post('/education_web_means/api/reportUploadImg', FormDatas,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }).then((response) => {
              loading.close();
              if (file.filename == 'list') {
                _this.form2.reportDetailsOfTrainingPlacesList[file.data.index].sitePicture = response.data.url
              } else {
                _this.form2.reportDetailsOfTrainingPlacesList[file.data.index].material = response.data.url
              }

            }).catch(e => {
              loading.close();
              ElMessage.error('上传失败')
              console.log(e)
            })
          },
          error(err) {
            //错误处理
            console.log(err.message)
          }
        })
      } else {
        let FormDatas = new FormData();
        FormDatas.append('fileName', file.file);
        _this.$http.post('/education_web_means/api/reportUploadImg', FormDatas,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then((response) => {
          loading.close();
          if (file.filename == 'list') {
            _this.form2.reportDetailsOfTrainingPlacesList[file.data.index].sitePicture = response.data.url
          } else {
            _this.form2.reportDetailsOfTrainingPlacesList[file.data.index].material = response.data.url
          }

        }).catch(e => {
          loading.close();
          ElMessage.error('上传失败')
          console.log(e)
        })
      }


    },
    customUpload2(file) {
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: '资源正在上传，请耐心等候……',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: document.querySelector('#table')//loadin覆盖的dom元素节点
      });

      let _this = this
      let wz = file.file.name.split('.')[1];
      if (wz == 'jpg' || wz == 'png') {
        new Compressor(file.file, {
          quality: 0.1,
          success(result) {
            let filess = new File([result], file.file.name, {type: file.file.type})
            console.log(result)
            var FormDatas = new FormData();
            FormDatas.append('fileName', filess);
            _this.$http.post('/education_web_means/api/reportUploadImg', FormDatas, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then((response) => {
              loading.close();
              let str = response.data.url
              switch (parseInt(file.filename)) {
                case 1:
                  _this.form3.houseSafetyAppraisal = str;
                  break;
                case 2:
                  _this.form3.filingOfFireAdministrativeLicense = str;
                  break;
                case 3:
                  _this.form3.contingencyPlan = str;
                  break;
                case 4:
                  _this.form3.businessPremisesInsurance = str;
                  break;
                case 5:
                  _this.form3.securityInstitution = str;
                  break;
                case 6:
                  _this.form3.renyuanbaoxian = str;
              }
              localStorage.setItem('form3', JSON.stringify(_this.form3))
            }).catch(e => {
              loading.close();
              ElMessage.error('上传失败')
              console.log(e)
            })
          },
          error(err) {
            //错误处理
            console.log(err.message)
          }
        })
      } else {
        let FormDatas = new FormData();
        FormDatas.append('fileName', file.file);
        _this.$http.post('/education_web_means/api/reportUploadImg', FormDatas, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((response) => {
          loading.close();
          let str = response.data.url
          switch (parseInt(file.filename)) {
            case 1:
              _this.form3.houseSafetyAppraisal = str;
              break;
            case 2:
              _this.form3.filingOfFireAdministrativeLicense = str;
              break;
            case 3:
              _this.form3.contingencyPlan = str;
              break;
            case 4:
              _this.form3.businessPremisesInsurance = str;
              break;
            case 5:
              _this.form3.securityInstitution = str;
              break;
            case 6:
              _this.form3.renyuanbaoxian = str;
          }
          localStorage.setItem('form3', JSON.stringify(_this.form3))
        }).catch(e => {
          loading.close();
          ElMessage.error('上传失败')
          console.log(e)
        })
      }

    },
    customUpload3(file) {
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: '资源正在上传，请耐心等候……',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: document.querySelector('#table')//loadin覆盖的dom元素节点
      });
      let _this = this
      console.log(file.file.name.split('.')[1])
      let wz = file.file.name.split('.')[1];
      if (wz == 'jpg' || wz == 'png') {
        new Compressor(file.file, {
          quality: 0.1,
          success(result) {
            let filess = new File([result], file.file.name, {type: file.file.type})
            console.log(result)
            var FormDatas = new FormData();
            FormDatas.append('fileName', filess);
            _this.$http.post('/education_web_means/api/reportUploadImg', FormDatas, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then((response) => {
              loading.close();
              let str = response.data.url
              if (file.data.name === 'renyuan' || file.data.name === 'jijiu') {
                if (file.data.name === 'renyuan') {
                  _this.form3.reportSecurityGuardList[file.data.index].img = str
                }
                if (file.data.name === 'jijiu') {
                  _this.form3.reportMedicalFirstAidSuppliesList[file.data.index].img = str
                }
                localStorage.setItem('form3', JSON.stringify(_this.form3))
              }
              if (file.data.name === 'qicai') {
                _this.form4.reportFacilitiesAndEquipmentList[file.data.index].img = str
                localStorage.setItem('form4', JSON.stringify(_this.form4))
              }
            }).catch(e => {
              loading.close();
              ElMessage.error('上传失败')
              console.log(e)
            })
          },
          error(err) {
            //错误处理
            console.log(err.message)
          }
        })
      } else {
        let FormDatas = new FormData();
        FormDatas.append('fileName', file.file);
        _this.$http.post('/education_web_means/api/reportUploadImg', FormDatas, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((response) => {
          loading.close();
          let str = response.data.url
          if (file.data.name === 'renyuan' || file.data.name === 'jijiu') {
            if (file.data.name === 'renyuan') {
              _this.form3.reportSecurityGuardList[file.data.index].img = str
            }
            if (file.data.name === 'jijiu') {
              _this.form3.reportMedicalFirstAidSuppliesList[file.data.index].img = str
            }
            localStorage.setItem('form3', JSON.stringify(_this.form3))
          }
          if (file.data.name === 'qicai') {
            _this.form4.reportFacilitiesAndEquipmentList[file.data.index].img = str
            localStorage.setItem('form4', JSON.stringify(_this.form4))
          }
        }).catch(e => {
          loading.close();
          ElMessage.error('上传失败')
          console.log(e)
        })
      }

      //console.log(file)


    },
    customUpload4(file) {
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: '资源正在上传，请耐心等候……',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: document.querySelector('#table')//loadin覆盖的dom元素节点
      });
      let _this = this
      let wz = file.file.name.split('.')[1];
      if (wz == 'jpg' || wz == 'png') {
        new Compressor(file.file, {
          quality: 0.1,
          success(result) {
            let filess = new File([result], file.file.name, {type: file.file.type})
            console.log(result)
            var FormDatas = new FormData();
            FormDatas.append('fileName', filess);
            _this.$http.post('/education_web_means/api/reportUploadImg', FormDatas, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then((response) => {
              loading.close();
              let str = response.data.url
              console.log(file.data.name)
              if (file.data.name === 'cysfzz') {
                _this.management.managementIdcardz = str
              }
              if (file.data.name === 'cysfzf') {
                _this.management.managementIdcardf = str
              }
              if (file.data.name === 'contract1') {
                _this.management.managementContract = str
              }

              if (file.data.name === 'jlysfzz') {
                _this.coachReal.coachIdCardz = str
              }
              if (file.data.name === 'jlysfzf') {
                _this.coachReal.coachIdCardf = str
              }
              if (file.data.name === 'cyzgz') {
                _this.coachReal.coachProfessional = str
              }
              if (file.data.name === 'contract') {
                _this.coachReal.coachContract = str
              }
              if (file.data.name === 'contract2') {
                _this.Research.researchContract = str
              }
              if (file.data.name === 'jyrycyzgz') {
                _this.Research.researchProfessional = str
              }
              if (file.data.name === 'jyrysfzf') {
                _this.Research.researchIdCardf = str
              }
              if (file.data.name === 'jyrysfzz') {
                _this.Research.researchIdCardz = str
              }
              if (file.data.name === 'contract3') {
                _this.Treatment.treatmentContract = str
              }
              if (file.data.name === 'jjcyzgz') {
                _this.Treatment.treatmentProfessional = str
              }
              if (file.data.name === 'jjidcardz') {
                _this.Treatment.treatmentIdCardz = str
              }
              if (file.data.name === 'jjidcardf') {
                _this.Treatment.treatmentIdCardf = str
              }

              localStorage.setItem('form5', JSON.stringify(_this.form5))

            }).catch(e => {
              loading.close();
              ElMessage.error('上传失败')
              console.log(e)
            })
          },
          error(err) {
            //错误处理
            console.log(err.message)
          }
        })
      } else {
        let FormDatas = new FormData();
        FormDatas.append('fileName', file.file);
        _this.$http.post('/education_web_means/api/reportUploadImg', FormDatas, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((response) => {
          loading.close();
          let str = response.data.url
          console.log(file.data.name)
          if (file.data.name === 'cysfzz') {
            _this.management.managementIdcardz = str
          }
          if (file.data.name === 'cysfzf') {
            _this.management.managementIdcardf = str
          }
          if (file.data.name === 'contract1') {
            _this.management.managementContract = str
          }

          if (file.data.name === 'jlysfzz') {
            _this.coachReal.coachIdCardz = str
          }
          if (file.data.name === 'jlysfzf') {
            _this.coachReal.coachIdCardf = str
          }
          if (file.data.name === 'cyzgz') {
            _this.coachReal.coachProfessional = str
          }
          if (file.data.name === 'contract') {
            _this.coachReal.coachContract = str
          }
          if (file.data.name === 'contract2') {
            _this.Research.researchContract = str
          }
          if (file.data.name === 'jyrycyzgz') {
            _this.Research.researchProfessional = str
          }
          if (file.data.name === 'jyrysfzf') {
            _this.Research.researchIdCardf = str
          }
          if (file.data.name === 'jyrysfzz') {
            _this.Research.researchIdCardz = str
          }
          if (file.data.name === 'contract3') {
            _this.Treatment.treatmentContract = str
          }
          if (file.data.name === 'jjcyzgz') {
            _this.Treatment.treatmentProfessional = str
          }
          if (file.data.name === 'jjidcardz') {
            _this.Treatment.treatmentIdCardz = str
          }
          if (file.data.name === 'jjidcardf') {
            _this.Treatment.treatmentIdCardf = str
          }


          localStorage.setItem('form5', JSON.stringify(_this.form5))

        }).catch(e => {
          loading.close();
          ElMessage.error('上传失败')
          console.log(e)
        })
      }
    },
    jichutijiao() {
      let _this = this
      let form
      window.scrollTo(0, 0);
      switch (this.type) {
        case 1:
          if (!this.form.companyName) {
            ElMessage.error('请输入机构名称')
            return false;
          }

          if (!this.form.organizer) {
            if (!this.yyzz1) {
              ElMessage.error('请输入举办者')
              return false;
            }
          }
          if (this.form.quality == 2) {
            this.form.organizerIdCard = this.form.fridcard
            this.form.organizer = this.form.frname
          }
          if (!this.form.organizerIdCard) {
            if (!this.yyzz1) {
              ElMessage.error('请输入举办者身份证号')
              return false;
            }
          }
          if(!this.yyzz){
            if (!this.form.notice) {
              if (!this.yyzz) {
                ElMessage.error('请上传申报名称预留告知书')
                return false;
              }
            }
          }
          if(this.yyzz){
            this.form.notice=''
          }

          if (!this.form.phone) {
            ElMessage.error('请输入举办者手机号')
            return false;

          }
          if (!this.form.code) {
            ElMessage.error('请输入短信验证码')
            return false
          }
          if (!this.form.registeredCapital) {
            ElMessage.error('请输入注册资金')
            return false;
          }
          if (parseFloat(this.form.registeredCapital) < 30) {
            ElMessage.error('注册资金不得小于30万元')
            return false;
          }
          if (this.checked&&this.form.quality==1) {
            this.form.personLiable = this.form.organizer
            this.form.personLiableIdCard = this.form.organizerIdCard
            this.form.personLiableIdCardz = this.form.organizerIdCardz
            this.form.personLiableIdCardf = this.form.organizerIdCardf
            this.form.crimez = this.form.crimej
          }
          if (!this.form.personLiable) {
            ElMessage.error('请输入责任者')
            return false;
          }
          if (!this.form.personLiableIdCard) {
            ElMessage.error('请输入责任者身份证号')
            return false;
          }
          if (!this.form.institutionalRulesAndRegulations) {
            ElMessage.error('请上传组织规章制度')
            return false;
          }

          form = {
            companyName: this.form.companyName,
            organizationType: this.form.organizationType,
            highRiskSports: this.form.highRiskSports,
            organizer: this.form.organizer,
            organizerIdCard: this.form.organizerIdCard,
            phone: this.form.phone,
            code: this.form.code,
            fridcard: this.form.fridcard,
            frname: this.form.frname,
            registeredCapital: this.form.registeredCapital,
            personLiable: this.form.personLiable,
            personLiableIdCard: this.form.personLiableIdCard,
            institutionalRulesAndRegulations: this.form.institutionalRulesAndRegulations,
            personLiableIdCardz: this.form.personLiableIdCardz,
            personLiableIdCardf: this.form.personLiableIdCardf,
            crimez: this.form.crimez,
            crimej: this.form.crimej,
            organizerIdCardz: this.form.organizerIdCardz,
            organizerIdCardf: this.form.organizerIdCardf,
            businessLicensej: this.form.businessLicensej,
            socialUnifiedCodej: this.form.socialUnifiedCodej,
            notice: this.form.notice,
            yylicense: this.form.yylicense,
            yycivilnon: this.form.yycivilnon,
            credit: this.form.credit,
            fridcardz: this.form.fridcardz,
            fridcardf: this.form.fridcardf,
            attorney: this.form.attorney,
            clientname: this.form.clientname,
            clientidcardz: this.form.clientidcardz,
            clientidcardf: this.form.clientidcardz,
            deposit: this.form.deposit,
            cardnumber: this.form.cardnumber,
            certificate: this.form.certificate,
            quality: this.form.quality
          }
          if (this.yyzz) {
            // if (!this.form.businessLicense) {
            //   ElMessage.error('请上传营业执照')
            //   return false;
            // }
            if (!this.form.socialUnifiedCode) {
              ElMessage.error('请输入社会统一代码')
              return false;
            }
            form.businessLicense = this.form.businessLicense
            form.socialUnifiedCode = this.form.socialUnifiedCode
          }


          report_base(form).then(res => {
            if (!(res.header.status == 0)) {
              ElMessage.error(res.header.msg)
              return false;
            }
            if (res.header.status == 0) {

              ElMessage.success(res.header.msg)
              _this.form.reportBaseId = res.data.id
              _this.form.token = res.data.token
              _this.form5 = {
                management: [],
                coachReal: [],
                Research: [],
                Treatment: []
              }
              localStorage.setItem('reportBaseId', res.data.id)
              localStorage.setItem('token', res.data.token)
              _this.type = 5
              console.log(_this.type)
              localStorage.setItem('type', _this.type)
              localStorage.setItem('reportBaseId', res.data.id)
              localStorage.setItem('token', res.data.token)

            }

          })
          break;
        case 2:
          if (this.form2.province == 0) {
            ElMessage.error('请选择省份')
            return false;
          }
          if (this.form2.city == 0) {
            ElMessage.error('请选择城市')
            return false;
          }
          if (this.form2.district == 0) {
            ElMessage.error('请选择区域')
            return false;
          }
          if (!this.form2.address) {
            ElMessage.error('请输入详细地址')
            return false;
          }
          if (this.form2.siteType == 0) {
            ElMessage.error('请选择场地性质')
            return false;
          }
          if (!this.form2.certificateOfPropertyRights) {
            if (this.form2.siteType == 1) {
              ElMessage.error('请上传产权证明')
            } else {
              ElMessage.error('请上租赁合同')
            }
            return false;
          }
          if (!this.form2.totalSiteArea) {
            ElMessage.error('请输入场地总面积')
            return false;
          }
          console.log(this.form2.reportDetailsOfTrainingPlacesList)
          if (!this.form2.reportDetailsOfTrainingPlacesList.length < 1) {
            if (this.form2.reportDetailsOfTrainingPlacesList[0].siteArea == '') {
              ElMessage.error('请至少添加一个培训项目')
              return false;
            }
          }
          var relist = [];
          this.form2.reportDetailsOfTrainingPlacesList.forEach(k => {
            k.areaId = parseInt(this.form2.district)
            k.numberOfShifts = parseInt(k.numberOfShifts)
            k.siteArea = parseFloat(k.siteArea)
            if (k.trainingPrograms == '其他') {
              k.trainingPrograms = k.trainingPrograms1
            }
            relist.push({
              trainingPrograms: k.trainingPrograms,
              numberOfShifts: k.numberOfShifts,
              siteArea: k.siteArea,
              sitePicture: k.sitePicture,
              material: k.material
            })
          })
            this.dellist.forEach(k=>{
              relist.push(k)
            })
          this.form2.reportDetailsOfTrainingPlacesList.forEach(k => {
            if (!k.numberOfShifts) {
              ElMessage.error('请输入最大班容量')
              return false;
            }
            if (!k.sitePicture   ) {
              ElMessage.error('请上传场地现状')
              return false;
            }
            if (!k.siteArea) {
              ElMessage.error('请输入培训教学面积')
              return false;
            }
            if (!k.material) {
              ElMessage.error('请上传课程体系图片')
              return false;
            }
            if (!k.trainingPrograms) {
              ElMessage.error('请输入培训项目')
              return false;
            }


          })
          this.form2.reportDetailsOfTrainingPlacesList = relist
          this.form2.totalSiteArea = parseFloat(this.form2.totalSiteArea)
          this.form2.reportBaseId = localStorage.getItem('reportBaseId')
          this.form2.token = localStorage.getItem('token')
          report_training_site(this.form2).then(res => {
            if (!(res.header.status == 0)) {
              ElMessage.error(res.header.msg)
              return false;
            }
            if (res.header.status == 0) {
              localStorage.setItem('reportBaseId', res.data.id)
              localStorage.setItem('token', res.data.token)
              this.type = 3
              localStorage.setItem('type', this.type)
            }
          })
          break;
        case 3:
          if(this.yyzz){
            if(!this.form3.businessPremisesInsurance){
              ElMessage.error('请上传经营场所险')
              return false
            }
            if(!this.form3.renyuanbaoxian){
              ElMessage.error('请上传人云保险')
              return false
            }
          }

          if (this.form3.reportSecurityGuardList.length < 1) {
            if (this.form3.reportSecurityGuardList.realName == '') {
              ElMessage.error('至少添加一个安保人员')
              return false
            }
          }
          if (this.form3.reportMedicalFirstAidSuppliesList.length < 1) {
            if (this.form3.reportMedicalFirstAidSuppliesList.itemName == '') {
              ElMessage.error('至少添加一个急救物品')
              ElMessage.error('至少添加一个急救物品')
              return false
            }
          }
          if (this.form5.Treatment.length < 1) {
            ElMessage.error('至少添加一个急救人员')
            return false

          }
          this.form3.reportSecurityGuardList.forEach(k=>{
            if(!k.img){
              ElMessage.error('请上传安保人员资质证书')
              return false
            }
            if(!k.realName){
              ElMessage.error('请输入安保人员姓名')
              return false
            }
            if(!k.idCard){
              ElMessage.error('请输入安保人员身份证号')
              return false
            }
          })
          this.form3.reportMedicalFirstAidSuppliesList.forEach(k=>{
            if(!k.itemName){
              ElMessage.error('请输入急救物品名称')
              return false
            }
            if(!k.unitType){
              ElMessage.error('请输入急救物品品类')
              return false
            }
            if(!k.img){
              ElMessage.error('请上传急救物品图片')
              return false
            }
          })
          this.form3.token = localStorage.getItem('token')
          this.form3.reportBaseId = localStorage.getItem('reportBaseId')
          report_protective_measure(this.form3).then(res => {
            if (!(res.header.status == 0)) {
              ElMessage.error(res.header.msg)
              return false;
            }
            if (res.header.status == 0) {
              localStorage.setItem('reportBaseId', res.data.id)
              localStorage.setItem('token', res.data.token)
              this.form4.protectiveMeasureId = res.data.protective_measure_id
              this.type = 4
              localStorage.setItem('type', this.type)
            }
          })
          break;
        case 4:
          this.form4.token = localStorage.getItem('token')
          this.form4.reportBaseId = localStorage.getItem('reportBaseId')
          report_facilities_and_equipment(this.form4).then(res => {
            if (!(res.header.status == 0)) {
              ElMessage.error(res.header.msg)
              return false;
            }
            if (res.header.status == 0) {
              alert('提交成功')
              this.type = 1
              localStorage.setItem('type', this.type)
              this.$router.push('/')
            }
          })
          break;
        case 5:
          if (_this.form5.management.length < 1) {
            ElMessage.error('请最少添加一个其他人员')
            return false
          }
          if (_this.form5.coachReal.length < 1) {
            ElMessage.error('请最少添加一个执教人员')
            return false
          }
          if (_this.form5.Research.length < 1) {
            ElMessage.error('请最少添加一个教研人员')
            return false
          }
          _this.type = 2
          localStorage.setItem('type', _this.type)
          break;
      }
    }
    ,
    jichutijiao1() {
      window.scrollTo(0, 0);
      //console.log(1)
      switch (this.type) {
        case 1:
          this.type = 1
          break;
        case 2:
          this.type = 5
            this.form.quality = this.form.quality+''
          break;
        case 3:
          this.type = 2
          break;
        case 4:
          this.type = 3
          break;
        case 5:
          this.type = 1
          this.form.quality = parseInt(this.form.quality)+''
      }
      localStorage.setItem('type', this.type)
      let forms = {
        "token": localStorage.getItem('token'),
        "id": localStorage.getItem('reportBaseId')
      }
      filing_progress_query(forms).then(res => {
        console.log(res)
        if (!res.data) {
          ElMessage.error(res.header.msg)
        }
        if (res.data) {
          localStorage.setItem('cxjg', JSON.stringify(res.data))
          localStorage.setItem('reportBaseId', res.data.id)
          localStorage.setItem('token', res.data.token)
          this.$router.push('/update')
        }
      })


    }
    ,
    changeCode(data, type) {
      if (type == 0) {
        this.form2.province = data
        this.form2.city = 0
        this.form2.district = 0
        this.cityArry = [{code: 0, name: '请选择'}]
        this.districtArry = [{code: 0, name: '请先选择城市'}]
        cit.forEach(k => {
          if (k.fcode == data) {
            this.cityArry.push({code: k.code, name: k.name})
          }
        })
      }
      if (type == 1) {
        this.form2.city = data
        this.form2.district = 0
        this.districtArry = [{code: 0, name: '请选择'}]
        dis.forEach(k => {
          if (k.fcode == data) {
            this.districtArry.push({code: k.code, name: k.name})
          }
        })
      }
      if (type == 2) {
        this.form2.district = data
        this.form3.areaId = data
      }
      localStorage.setItem('form2', JSON.stringify(this.form2))
    }
    ,
    /*增加场地*/
    zengjiachangdi() {
      let list = this.form2.reportDetailsOfTrainingPlacesList
      list.push({
        "trainingPrograms": "",
        "numberOfShifts": '',
        "siteArea": '',
        "sitePicture": ""
      })
      this.form2.reportDetailsOfTrainingPlacesList = list
    }
    ,
    //删除场地
    shanchuchangdi() {
      let list = this.form2.reportDetailsOfTrainingPlacesList
      if (list.length < 2) {
        ElMessage.error('最少需要填写一个场地')
        return;
      } else {
        this.form2.reportDetailsOfTrainingPlacesList[list.length - 1].del =1
        this.dellist.push(this.form2.reportDetailsOfTrainingPlacesList[list.length - 1])
        list = list.splice(0, list.length - 1)
        this.form2.reportDetailsOfTrainingPlacesList = list
      }
      localStorage.setItem('form2', JSON.stringify(this.form2))
    }
    ,

    /*增加人员*/
    addrenyuan() {
      let list = this.form3.reportSecurityGuardList
      list.push({
        "trainingPrograms": "",
        "numberOfShifts": '',
        "siteArea": '',
        "sitePicture": ""
      })
      this.form3.reportSecurityGuardList = list
    }
    ,
    //删除人员
    delrenyuan(e) {
      //console.log(e)
      this.form3.reportSecurityGuardList.splice(e, 1)
      localStorage.setItem('form3', JSON.stringify(this.form3))
    }
    ,
    /*增加场地*/
    addjijiu() {
      let list = this.form3.reportMedicalFirstAidSuppliesList
      list.push({
        "trainingPrograms": "",
        "numberOfShifts": '',
        "siteArea": '',
        "sitePicture": ""
      })
      this.form3.reportMedicalFirstAidSuppliesList = list
    }
    ,
    //删除场地
    deljijiu(e) {
      //console.log(e)
      this.form3.reportMedicalFirstAidSuppliesList.splice(e, 1)
      localStorage.setItem('form3', JSON.stringify(this.form3))
    }
    ,
    /*增加设备*/
    addshebei() {
      let list = this.form4.reportFacilitiesAndEquipmentList
      list.push({
        "trainingPrograms": "",
        "numberOfShifts": '',
        "siteArea": '',
        "sitePicture": ""
      })
      this.form4.reportFacilitiesAndEquipmentList = list
    }
    ,
    //删除设备
    delshebei(e) {
      this.form4.reportFacilitiesAndEquipmentList.splice(e, 1)
      localStorage.setItem('form4', JSON.stringify(this.form4))
    }
    ,
    /*增加行政*/
    addxingzheng() {
      let _this = this
      let list = this.management
      list.reportBaseId = localStorage.getItem('reportBaseId')
      list.token = localStorage.getItem('token')
      console.log(list)
      if (list.managementRealName == '') {
        ElMessage.error('请输入其他人员姓名')
        return false;
      }
      if (list.managementIdCard == '') {
        ElMessage.error('请输入其他人员身证号')
        return false;
      }
      if (list.managementIdcardz == ''||list.managementIdcardz == 'https://www.qianhedu.com/img/zm.png') {
        ElMessage.error('请上传其他人员身份证正面')
        return false;
      }
      if (list.managementIdcardf == ''||list.managementIdcardf == 'https://www.qianhedu.com/img/zm.png') {
        ElMessage.error('请上传其他人员身份证反面')
        return false;
      }
      if (list.managementContract == ''||list.managementContract == 'https://www.qianhedu.com/img/zm.png') {
        ElMessage.error('请上传其他人员劳动合同')
        return false;
      }
      addManagement(list).then(res => {
        if (!(res.header.status == 0)) {
          ElMessage.error(res.header.msg)
          return false;
        }
        if (res.header.status == 0) {
          localStorage.setItem('reportBaseId', res.data.id)
          localStorage.setItem('token', res.data.token)
          list.managementId = res.data.managementId
          _this.form5.management.push(list)
          localStorage.setItem('form5', JSON.stringify(_this.form5))
          window.location.reload();
        }
      })
    }
    ,
    //删除行政
    delxingzheng(e) {
      let _this = this
      delManagement({
        managementId: this.form5.management[e].managementId,
        reportBaseId: localStorage.getItem('reportBaseId'),
        token: localStorage.getItem('token')
      }).then(res => {
        if (!(res.header.status == 0)) {
          ElMessage.error(res.header.msg)
          return false;
        }

        _this.form5.management.splice(e, 1)
        localStorage.setItem('form5', JSON.stringify(this.form5))

      })

    }
    ,
    /*增加教员*/
    addjiaoyuan() {
      let _this = this
      let list = this.coachReal
      list.reportBaseId = localStorage.getItem('reportBaseId')
      list.token = localStorage.getItem('token')
      if (list.coachRealName == '') {
        ElMessage.error('请输入执教人员姓名')
        return false;
      }
      if (list.coachIdCard == '') {
        ElMessage.error('请输入执教人员身证号')
        return false;
      }
      if (list.coachIdCardz == ''||list.coachIdCardz == 'https://www.qianhedu.com/img/zm.png') {
        ElMessage.error('请上传执教人员身份证正面')
        return false;
      }
      if (list.coachIdCardf == ''||list.coachIdCardf == 'https://www.qianhedu.com/img/zm.png') {
        ElMessage.error('请上传执教人员身份证反面')
        return false;
      }
      if (list.coachProfessional == ''||list.coachProfessional == 'https://www.qianhedu.com/img/zm.png') {
        ElMessage.error('请上传执教人员从业资格证书')
        return false;
      }
      if (list.coachContract == ''||list.coachContract == 'https://www.qianhedu.com/img/zm.png') {
        ElMessage.error('请上传执教人员劳动合同')
        return false;
      }
      addCoach(list).then(res => {
        if (!(res.header.status == 0)) {
          ElMessage.error(res.header.msg)
          return false;
        }
        if (res.header.status == 0) {
          localStorage.setItem('reportBaseId', res.data.id)
          localStorage.setItem('token', res.data.token)
          list.coachId = res.data.coachId
          _this.form5.coachReal.push(list)
          localStorage.setItem('form5', JSON.stringify(_this.form5))
          window.location.reload();
        }
      })
    }
    ,
    //删除教员
    deljiaoyuan(e) {
      let _this = this
      delCoach({
        coachId: this.form5.coachReal[e].coachId,
        reportBaseId: localStorage.getItem('reportBaseId'),
        token: localStorage.getItem('token')
      }).then(res => {
        if (!(res.header.status == 0)) {
          ElMessage.error(res.header.msg)
          return false;
        }
        _this.form5.coachReal.splice(e, 1)
        localStorage.setItem('form5', JSON.stringify(this.form5))

      })

    }
    ,
    /*增加教研人员*/
    addjiaoyan() {
      let _this = this
      let list = this.Research
      list.reportBaseId = localStorage.getItem('reportBaseId')
      list.token = localStorage.getItem('token')
      if (list.researchRealName == '') {
        ElMessage.error('请输入教研人员姓名')
        return false;
      }
      if (list.researchIdCard == '') {
        ElMessage.error('请输入教研人员身证号')
        return false;
      }
      if (list.researchIdCardz == ''||list.researchIdCardz == 'https://www.qianhedu.com/img/zm.png') {
        ElMessage.error('请上传教研人员身份证正面')
        return false;
      }
      if (list.researchIdCardf == ''||list.researchIdCardf == 'https://www.qianhedu.com/img/zm.png') {
        ElMessage.error('请上传教研人员身份证反面')
        return false;
      }
      if (list.researchProfessional == ''||list.researchProfessional == 'https://www.qianhedu.com/img/zm.png') {
        ElMessage.error('请上传教研人员从业资格证书')
        return false;
      }
      if (list.researchContract == ''||list.researchContract == 'https://www.qianhedu.com/img/zm.png') {
        ElMessage.error('请上传教研人员劳动合同')
        return false;
      }
      addResearch(list).then(res => {
        if (!(res.header.status == 0)) {
          ElMessage.error(res.header.msg)
          return false;
        }
        if (res.header.status == 0) {
          localStorage.setItem('reportBaseId', res.data.id)
          localStorage.setItem('token', res.data.token)
          list.researchId = res.data.researchId
          _this.form5.Research.push(list)
          localStorage.setItem('form5', JSON.stringify(_this.form5))
          window.location.reload();
        }
      })
    }
    ,
    //删除教研人员
    deljiaoyan(e) {
      console.log(e)
      let _this = this
      delResearch({
        researchId: this.form5.Research[e].researchId,
        reportBaseId: localStorage.getItem('reportBaseId'),
        token: localStorage.getItem('token')
      }).then(res => {
        if (!(res.header.status == 0)) {
          ElMessage.error(res.header.msg)
          return false;
        }
        _this.form5.Research.splice(e, 1)
        localStorage.setItem('form5', JSON.stringify(this.form5))
      })

    },
    addjijiury() {
      let _this = this
      let list = this.Treatment
      list.reportBaseId = localStorage.getItem('reportBaseId')
      list.token = localStorage.getItem('token')
      if (list.treatmentRealName == '') {
        ElMessage.error('请输入急救人员姓名')
        return false;
      }
      if (list.treatmentIdCard == '') {
        ElMessage.error('请输入急救人员身证号')
        return false;
      }
      if (list.treatmentIdCardz == '') {
        ElMessage.error('请上传急救人员身份证正面')
        return false;
      }
      if (list.treatmentIdCardf == '') {
        ElMessage.error('请上传急救人员身份证反面')
        return false;
      }
      if (list.treatmentProfessional == '') {
        ElMessage.error('请上传执急救员从业资格证书')
        return false;
      }
      if(list.treatmentContract==''){
        ElMessage.error('请上传执急救员劳动合同')
        return false;
      }
      addTreatment(list).then(res => {
        if (!(res.header.status == 0)) {
          ElMessage.error(res.header.msg)
          return false;
        }
        if (res.header.status == 0) {
          localStorage.setItem('reportBaseId', res.data.id)
          localStorage.setItem('token', res.data.token)
          list.treatmentId = res.data.treatmentId
          _this.form5.Treatment.push(list)
          localStorage.setItem('form5', JSON.stringify(_this.form5))
          _this.Treatment = {
            "treatmentRealName": "",//教练真实姓名
            "treatmentIdCard": "",//教练身份证号码
            "treatmentIdCardz": "",//身份证正面照片
            "treatmentIdCardf": "",//身份证反面照片
            "treatmentProfessional": '',
            "treatmentContract": ""
          }
        }
      })
    }
    ,
    //删除教研人员
    deljijiury(e) {
      let _this = this
      console.log(this.form5.Treatment[e])
      delTreatment({
        treatmentId: this.form5.Treatment[e].treatmentId,
        reportBaseId: localStorage.getItem('reportBaseId'),
        token: localStorage.getItem('token')
      }).then(res => {
        console.log(res)
        if (res.header.status == 0) {
          ElMessage.success(res.header.msg)
          _this.form5.Treatment.splice(e, 1)
          localStorage.setItem('form5', JSON.stringify(this.form5))
        }
      })

    }

  }
}
</script>
<style scoped>

#u58 {
  margin-top: 40px;
  background: rgb(242, 242, 242);
  height: 120px;
  padding: 10px 0;
  font-size: 16px;
}

#u51_img {
  width: 1000px;
}

#u52_img {
  border-width: 0px;
  position: absolute;
  left: 32px;
  top: 62px;
  width: 342px;
  height: 76px;
}

.jindu {
  margin-top: 20px;
  display: flex;
  margin-left: 5px;
}

.jindu .p1 {
  width: 30px;
  height: 30px;
  border-radius: 100px;
  background: #CCCCCC;
  color: white;
  text-align: center;
  line-height: 30px;
  margin: 0 auto;
}

.jindu .span1 {
  width: 96px;
  text-align: center;
  font-size: 14px;
  color: #CCCCCC;
}

.jindu .p2 {
  width: 30px;
  height: 30px;
  border-radius: 100px;
  background: #FF0000;
  color: white;
  text-align: center;
  line-height: 30px;
  margin: 0 auto;
}

.jindu .span2 {
  width: 96px;
  text-align: center;
  font-size: 14px;
  color: #FF0000;
}


.imgx {
  margin-left: -25px;
}

.jindu div {
  margin-left: 20px;
}

.hang {
  margin-left: 150px;
  color: black;
  font-size: 16px;
}

.inputs {
  width: 40%;
  margin-left: 10px;
}

.selects {
  width: 40%;
  margin-left: 10px;
}

.xing {
  color: red;
  font-size: 18px;
  margin-left: 5px;
}

.bei {
  font-size: 16px;
  margin-left: 30px;
  color: #c9c9c9;
}


.el-form-item label {
  color: black;
  font-size: 16px;
}

.buttons {
  cursor: pointer;
  border-width: 0px;
  width: 15%;
  height: 30px;
  background: inherit;
  background-color: rgba(255, 102, 51, 1);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;
  text-align: center;
}

.buttons1 {
  cursor: pointer;
  border-width: 0px;
  width: 40px;
  text-align: center;
  height: 30px;
  background: inherit;
  background-color: #409eff;
  border: none;
  border-radius: 3px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;
}

.buttons2 {
  cursor: pointer;
  position: relative;
  left: 37%;
  width: 190px;
  height: 45px;
  background: inherit;
  background-color: rgba(255, 51, 51, 1);
  border: none;
  border-radius: 3px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;
  text-align: center;
  line-height: 45px;
}

.buttons3 {
  cursor: pointer;
  position: relative;
  left: 20%;
  width: 190px;
  height: 45px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(255, 51, 51, 1);
  border-radius: 3px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FF3333;
  text-align: center;
  line-height: 45px;
}


</style>
